<template>
  <div class="chat-bot">
    <div class="chat-panel" v-show="isOpen"  @touchmove="onPanelTouchMove">
      <!-- 头部 -->
      <!-- pc -->
      <div v-show="!isPortrait" class="pc-chat-header">
        <img class="pc-head-icon" src="/assets/~/media/images/ai/pc-head-icon.png" alt="">
        <div class="pc-header-actions" @click="newChat">
          <img src="/assets/~/media/images/ai/plus-icon.png" alt="">
          <div style="line-height: 1;" code-stm="event, PAGEURL, 机器人聊天-顶部-点击‘新聊天’按钮">新聊天</div>
        </div>
      </div>
      <!-- mob -->
      <div v-show="isPortrait" class="mob-chat-header" :style="{ backgroundColor: `rgba(255, 255, 255, ${headerOpacity})`, transition: 'background-color 0.3s ease' }">
        <img class="mob-back-icon"  
             src="/assets/~/media/images/ai/mob-back-icon.png" 
             @touchstart="handleBackTouchStart"
             @touchend="handleBackTouchEnd"
             alt="">
        <img class="mob-head-icon" src="/assets/~/media/images/ai/mob-head-icon.png" alt="">
        <img class="mob-newchat-icon" 
             src="/assets/~/media/images/ai/mob-newchat-icon.png" 
             
             @touchstart="handleNewChatTouchStart"
             @touchend="handleNewChatTouchEnd"
             alt="">
      </div>

      <!-- 对话区 -->
      <div class="chat-body" ref="chatBody">
          <!-- 欢迎语 --> 
          <!-- mob 的图标 -->
          <div v-show="isPortrait" class="robot-head-container-mob">
            <img class="blue-background" src="/assets/~/media/images/ai/blue-background.png" alt="">
            <img class="robot-head-img" src="/assets/~/media/images/ai/robot-head-gif.gif" alt="">
            <div class="robot-head-text">{{ robotTypedText }}</div>
          </div>
          <!-- pc -->
          <div class="chat-msg mob-welcome-message">
            <div v-show="!isPortrait" class="robot-head">
              <img class="robot-head-img" src="/assets/~/media/images/ai/robot-head-gif.gif" alt="">
              <div class="robot-head-text">{{ robotTypedText }}</div>
            </div>
            <div class="bubble" style="width: 100%;">
              <div class="welcome-content">
                <div class="welcome-desc" :class="['appear-seq', { showshow: welcomeAppearIndex >= 1 }]">
                  <!-- {{ welcomeMessage }} -->
                  随时为您解答各类问题。无论是购车指南还是品牌资讯，起亚都能快速为您提供帮助。
                </div>
                <div class="welcome-desc-bottom" :class="['appear-seq', { showshow: welcomeAppearIndex >= 2 }]">
                  点击下方高频问题快速提问，或直接输入需求，起亚即刻为您服务!
                </div>
                <div class="welcome-recommend" v-if="recommendations.length">
                  <div class="ai-recommend-list">
                    <div class="recommend-item" 
                      :class="['appear-seq', { loading: isRecommendationsLoading, showshow: welcomeAppearIndex >= (3 + idx) }]"
                      @click="!isRecommendationsLoading && handlePickQuestion(q)"
                      v-for="(q, idx) in recommendations" :key="idx">
                      <img class="hashtag-icon" src="/assets/~/media/images/ai/hashtag-icon.png" alt="">
                      <div v-if="isRecommendationsLoading" class="loading-text"></div>
                      <div v-else>{{ q }}</div>
                    </div>
                  </div>
                  <div class="recommend-actions">
                    <div class="change-btn" @click="spinAndShuffle">
                      <img class="change-icon" :class="{ spinning: isChangeSpinning }" src="/assets/~/media/images/ai/refresh-icon.png" alt="换一批" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <!-- 历史消息 -->
        <div v-for="(m, i) in messages" :key="i" class="chat-msg msg" :class="m.role === 'assistant' ? 'msg-bot' : 'msg-user'">
          <div class="avatar" :class="m.role === 'assistant' ? 'assistant' : 'user'">
            <img v-if="m.role === 'assistant'" class="avatar-bot-img" src="/assets/~/media/images/ai/robot-head.png" alt="AI" />
            <div  v-if="m.role === 'assistant'" class="avatar-bot-text">
              起亚
 <span v-if=" i === messages.length - 1 && !m.text" class="thinking-text">正在思考</span>

            </div>
            <span v-else></span>
          </div>

           <!-- 添加思考动画 -->
            <div v-if=" i === messages.length - 1 && !m.text" class="thinking-container">
              <div class="thinking-dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
              <!-- <img src="/assets/~/media/images/ai/robot-thinking.gif" alt="正在思考" class="thinking-gif" /> -->
            </div>
          <!-- 文字回复 - 支持markdown -->
          <div class="bubble" v-if="m.role === 'assistant'  && !(i === messages.length - 1 && !m.text)">
            
            <!-- 经销商类型显示固定文字 -->
            <!-- <div v-if="isPortrait && m.questionType === '3' && m.isExtractSuccess == '1'" class="dealer-text">
              请点击下方按钮查找经销商
            </div> -->
            <!-- 车型对比类型显示固定文字 -->
            <!-- <div v-else-if="isPortrait && m.questionType === '2' && m.isExtractSuccess == '1'" class="compare-text">
              请点击下方按钮查看车型对比详情
            </div> -->
            <!-- 其他类型显示动态内容 -->
            <!-- <div v-else class="md-output" v-html="renderMarkdown(m.text)"></div> -->
            <!-- <div v-else v-html="m.text"></div> -->
             <div class="md-output" v-html="renderMarkdown(m.text)"></div>
            
            <!-- 根据回复类型显示不同按钮 -->
            <!-- 经销商相关按钮 -->
            <div v-if="isPortrait && m.questionType === '3' && m.isExtractSuccess == '1'" class="compare-btn" @click="handleDealerClick">
              <img src="/assets/~/media/images/ai/dealer-icon.png" alt="">
              <div>查看经销商</div>
              <img src="/assets/~/media/images/ai/right-arrow-icon.png" alt="" class="right-arrow">
            </div> 

            <!-- 车型对比相关按钮 -->
            <div v-if="isPortrait && m.questionType === '2' && m.isExtractSuccess == '1'" class="compare-btn" @click="handleCompareClick">
              <img src="/assets/~/media/images/ai/compare-icon.png" alt="">
              <div>查看车型对比详情</div>
              <img src="/assets/~/media/images/ai/right-arrow-icon.png" alt="" class="right-arrow">
            </div> 

          <!-- 查看图片和视频相关按钮 -->
           <!-- isPortrait &&  m.questionType !== '3' &&  m.questionType !== '2' &&  m.questionType !== '8' &&  m.questionType !== '7' && parseInt( m.questionType) < 9 && m.isExtractSuccess == '1' -->
            <div v-if="isPortrait &&  m.questionType === '1'  && parseInt( m.questionType) < 9 && m.isExtractSuccess == '1'" class="compare-btn" @click="handleImageVideoClick">
              <img src="/assets/~/media/images/ai/iv-more-icon.png" alt="">
              <div>查看更多</div>
              <img src="/assets/~/media/images/ai/right-arrow-icon.png" alt="" class="right-arrow">
            </div>



          </div>
          <div class="bubble" v-else-if="m.role !== 'assistant' || (m.text && !(i === messages.length - 1 && !m.text))" v-html="m.text"></div>

          <div v-if="m.role === 'assistant' && m.showDisclaimer" class="disclaimer">ⓘ 本回答由AI生成，内容仅供参考</div>
          <div v-if="m.role === 'assistant' && m.showSuggestions && m.suggestions && m.suggestions.length" class="reply-suggest">
            <div class="ai-recommend-list">
              <span class="recommend-item" v-for="(q, si) in m.suggestions" :key="si" @click="handlePickQuestion(q)">
                <img class="hashtag-icon" src="/assets/~/media/images/ai/hashtag-icon.png" alt="">
                <div>{{ q }}</div>
              </span> 
            </div>
          </div>
        </div>
      </div>

      <!-- 移动端 经销商弹窗（头部露出） -->
      <div v-if="isPortrait && showDealersOverlay" class="dealers-overlay" :style="{ top: mobHeaderHeight + 'px'}">
        <div class="dealers-overlay-panel" :style="{ top: '-2px' }">
          <!-- <div class="dealers-overlay-close" @click="closeDealersOverlay">×</div> -->
          <Dealers :question="dealerQuestion" :clientPosition="clientPosition" />
        </div>
      </div>
      <!-- 移动端 车型对比弹窗（头部露出） -->
      <div v-if="isPortrait && showCompareOverlay" class="dealers-overlay" :style="{ top: mobHeaderHeight + 'px'}">
        <div class="dealers-overlay-panel compare-overlay-panel">
          <div class="compare-header-mob">以下是为您整理的车型对比</div>
          <div class="compare-overlay-content">
            <Compare :question="compareQuestion" />
          </div>
        </div>
      </div>
      <!-- 移动端 图片视频查看弹窗（头部露出） -->
      <div v-if="isPortrait && showImageVideoOverlay" class="dealers-overlay" :style="{ top: mobHeaderHeight + 'px'}">
        <div class="dealers-overlay-panel compare-overlay-panel">
          <div class="compare-header-mob">以下是为您找到的图片和视频</div>
          <div class="compare-overlay-content-iv">   
            <ImageVideo :question="imageVideoQuestion" :enhancedQuestion="imageVideoEnhancedQuestionQuestion" :questionType="imageVideoQuestionType"    />
          </div>
        </div>
      </div> 

      <!-- 工具栏 + 输入区 --> 
      <div class="chat-footer">
        <div class="toolbar">
          <div class="toolbar-text"></div>
          <div class="toolbar-buttons">
            <el-button size="mini" class="tool-btn btn-dark" @click="goDealer">经销商查询</el-button>
            <el-button size="mini" class="tool-btn btn-light" @click="toggleForm">预约试驾</el-button>
          </div>
        </div>
        <div class="input-bar">
          <div class="input-wrap">
            <el-input :disabled="isStreaming || !noticeOk" v-model="inputText" placeholder="请输入您的问题" @keyup.enter.native="send"></el-input>
            <button class="send-circle" :disabled="isStreaming || !noticeOk" @click="send" :title="!noticeOk ? '请先同意用户须知' : '发送'">
              <img src="/assets/~/media/images/ai/send-icon.png" alt="send" />
            </button>
          </div>
        </div>
      </div>

      <!-- 留资控件弹层：仅在聊天面板内部自底向上弹出 -->
      <div class="form-mask" v-show="showForm">
        <div class="form-sheet" :class="{ closing: isClosing }">
          <MyFormMob :clientPosition="clientPosition || defaultClientPosition" @close="handleCloseForm" />
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
import { apiUrl } from '@/config/base';
import { aiUrl } from "@/config/base";
import MyFormMob from '@/components/mob/My-Form-mob.vue';
import Dealers from '@/components/pc/Dealers.vue';
import { marked } from 'marked';
import Compare from "./Compare.vue";
import ImageVideo from "./ImageVideo.vue";

export default {
  name: 'ChatBot',
  components: { MyFormMob, Dealers, Compare, ImageVideo },
  props: {
    clientPosition: {
      type: Object,
      default: null,
    },
    noticeAccepted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 仅让最新一条 AI 消息显示推荐内容
    lastAssistantIndex() {
      for (let idx = this.messages.length - 1; idx >= 0; idx -= 1) {
        if (this.messages[idx] && this.messages[idx].role === 'assistant') {
          return idx;
        }
      }
      return -1;
    },
    // 同意标志：优先使用父组件传入，其次读取本地存储
    noticeOk() {
      try {
        if (this.noticeAccepted) return true;
        const ts = localStorage.getItem('kia_ai_notice_accepted_at');
        return !!ts;
      } catch (_) {
        return !!this.noticeAccepted;
      }
    }
  },
  data() {
    return {
      isPortrait: isPortraitFun(),
      isOpen: true,
      showForm: false,
      showDealersOverlay: false,
      showCompareOverlay: false,
      showImageVideoOverlay: false,
      mobHeaderHeight: 0,
      inputText: '',
      welcomeText: '您好，我是起亚 AI 智能引导助手，有什么可以帮您？',
      welcomeMessage: '',
      messages: [],
      recommendedPool: [],
      recommendations: [],
      defaultClientPosition: { lng: '', lat: '' },
      dealerUrl: '',
      isStreaming: false,
      isClosing: false, // 新增：控制表单关闭动画
      isChangeSpinning: false,
      isRecommendationsLoading: false, // 新增：控制推荐列表加载状态
      // 头部打字机
      robotFullText: 'H i， 我是您的AI助手起亚',
      robotTypedText: '',
      // 欢迎区依次出现控制
      welcomeAppearIndex: 0,
      welcomeSequenceStarted: false,
      // 打字机效果的每字符延迟（毫秒）
      typewriterDelayMs: 16,
      // 触摸滚动代理（移动端）：用于在工具栏区域开始拖拽时把滚动交给聊天内容
      panelTouchStartY: 0,
      panelTouchTargetInChatBody: false,
      // 移动端点击状态管理
      mobClickedItems: new Set(), // 记录移动端已点击的项目
      // 返回按钮触摸状态
      isBackTouchActive: false,
      backTouchStartY: 0,

      // 问题类型
      dealerQuestion: '',
      compareQuestion: '',
      imageVideoQuestion: '',
      imageVideoQuestionType: '',
      imageVideoEnhancedQuestionQuestion: '', 
      // 动态生成的UUID
      currentUuid: '',

      idvisitor: '',
      token: '',
      pendingEntryQuestion: '',
      hasAutoSentEntry: false,
      hasBack: false,
      _idvisitorInitTimer: null,
      _idvisitorTries: 0,
      headerOpacity: 0, // 新增：头部透明度
      scrollThreshold: 50, // 新增：触发完全不透明的滚动阈值
      userScrolling: false, // 新增：用户是否正在查看历史消息
      questionSendText:'',
      currentQuestionType: null,
      currentNormalized: null,
      currentType4BotMsg: null,
      questionType4ChangeViewFlg: null
    };
  },
  created() {
    const userInfo = localStorage.getItem('user');
    var token=''
    if(userInfo){
      this.userInfo = JSON.parse(userInfo)
      token = this.userInfo.token
    }
    this.token = token

    this.initDealerUrl();
    this.fetchRecommendedPool();
    // 生成初始UUID
    this.generateNewUuid();
    // 兜底：先确保 idvisitor 不为空
    try { this.ensureIdvisitorNotEmpty(); } catch (_) {}
    // 提前尝试获取 Matomo 访客ID
    this.startIdvisitorInit();
    // 配置marked选项
    marked.setOptions({
      breaks: true, // 支持换行
      gfm: true, // 支持GitHub风格markdown
    });
    
    
    // 检查URL中的entryQuestion参数
    this.checkEntryQuestion();
  },
  mounted() {
    // var visitorInfo = window.Matomo.getTracker().getVisitorInfo()
    // if(visitorInfo){
    //   this.idvisitor = visitorInfo[1]
    // }
    window.addEventListener("resize", this.setResize);
    // 添加额外的滚动事件监听，当滚动到底部时重新计算布局
    if (this.$refs.chatBody) {
      this.$refs.chatBody.addEventListener('scroll', (e) => {
        this.handleScroll();
        
        // 检测是否滚动到底部
        const el = e.target;
        const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 10;
        if (isAtBottom && this.isPortrait && this.detectSpecialBrowsers()) {
          // 延迟调用以避免频繁计算
          if (this._layoutTimeout) clearTimeout(this._layoutTimeout);
          this._layoutTimeout = setTimeout(() => {
            this.setupFixedLayout();
          }, 100);
        }
      });
    }
  
    this.$nextTick(() => {
      this.computeMobHeaderHeight();
      // 百度浏览器特殊处理
      if (this.detectSpecialBrowsers() && this.isPortrait) {
        this.setupFixedLayout();
      } else {
        this.addMobileTouchListeners();
      }
      // 新增：添加滚动监听
      if (this.$refs.chatBody) {
        this.$refs.chatBody.addEventListener('scroll', this.handleScroll);
      }
    });
    this.startTypewriter();
    // 再次尝试读取入口问题（确保路由/Hash 就绪）并进行多次尝试
    this.$nextTick(() => {
      const schedule = [0, 200, 600, 1200, 2000];
      schedule.forEach(ms => setTimeout(() => this.tryAutoSendEntry(), ms));
    });
    // 计算是否有上一页
    this.computeHasBack();
    window.addEventListener('popstate', this.computeHasBack);
  },
  watch: {
    
    recommendations(newVal) {
      const len = Array.isArray(newVal) ? newVal.length : 0;
      const total = 2 + Math.min(3, len);
      if (!this.welcomeSequenceStarted) {
        // 无论是否有推荐项，均启动欢迎区动画（先两项，后续补充）
        this.$nextTick(() => this.startWelcomeSequence());
      } else if (this.welcomeAppearIndex < total) {
        // 若已启动，但推荐项到达后应继续补齐动画
        const runMore = () => {
          if (this.welcomeAppearIndex >= total) return;
          this.welcomeAppearIndex += 1;
          setTimeout(runMore, 150);
        };
        runMore();
      }
    },
    noticeAccepted(newVal) {
      if (newVal) {
        this.tryAutoSendEntry();
      }
    }
  },
  beforeDestroy() {
    this.removeMobileTouchListeners();
    try { window.removeEventListener('popstate', this.computeHasBack); } catch (_) {}
    // 新增：移除滚动监听
    if (this.$refs.chatBody) {
      this.$refs.chatBody.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    // 1. 首先添加百度浏览器检测方法
    // 增强的浏览器检测方法，全面覆盖荣耀浏览器标识
    detectSpecialBrowsers() {
      const ua = navigator.userAgent.toLowerCase();
      console.log('完整用户代理字符串:', ua);
      
      // 检测百度浏览器
      const isBaidu = ua.indexOf('baidubrowser') > -1 || 
                    ua.indexOf('baiduboxapp') > -1 ||
                    ua.indexOf('baidu') > -1;
      
      // 增强的荣耀浏览器检测
      const isHonor = ua.indexOf('honor') > -1 || 
                    ua.indexOf('magicui') > -1 || 
                    ua.indexOf('magicos') > -1 ||
                    ua.indexOf('huawei') > -1 || // 荣耀曾是华为子品牌
                    ua.indexOf('ali-an00') > -1 || // 荣耀X50型号标识
                    /hw[a-z0-9]+browser/i.test(ua); // 华为/荣耀浏览器模式
      
      // 检测其他可能有兼容性问题的移动浏览器
      const isProblematicMobileBrowser = isBaidu || isHonor;
      
      console.log('浏览器检测结果:', { 
        isBaidu, 
        isHonor, 
        isProblematicMobileBrowser 
      });
      return isProblematicMobileBrowser;
    },
    // 确保 idvisitor 不为空，失败则回退为 currentUuid，并持久化到 localStorage
    ensureIdvisitorNotEmpty() {
      try {
        if (!this.idvisitor || String(this.idvisitor).trim() === '') {
          const fromMatomo = this.getVisitorIdFromMatomo();
          const fromCookie = this.getVisitorIdFromCookie();
          this.idvisitor = fromMatomo || fromCookie || this.currentUuid || '';
          try { if (this.idvisitor) localStorage.setItem('kia_idvisitor', this.idvisitor); } catch (_) {}
        }
      } catch (_) {
        if (!this.idvisitor) this.idvisitor = this.currentUuid || '';
        try { if (this.idvisitor) localStorage.setItem('kia_idvisitor', this.idvisitor); } catch (_) {}
      }
    },
    // 新增：处理滚动事件，更新头部透明度
    handleScroll() {
      const scrollTop = this.$refs.chatBody.scrollTop;
      
      // 移动端：根据滚动距离计算透明度（0-1之间）
      if (this.isPortrait) {
        this.headerOpacity = Math.min(1, scrollTop / this.scrollThreshold);
      }
      
      // 检测用户是否在查看历史消息（PC和移动端都需要）
      const el = this.$refs.chatBody;
      if (el) {
        const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
        // 如果用户距离底部超过100px，认为在查看历史消息
        this.userScrolling = distanceToBottom > 100;
      }
    },
    // 尝试从 Matomo/Cookie 获取访客ID（多重兜底）
    getVisitorIdFromMatomo() {
      try {
        const t = window?.Matomo?.getTracker?.();
        if (t && t.getVisitorId) {
          return t.getVisitorId();
        }
        const info = t && t.getVisitorInfo ? t.getVisitorInfo() : (window?.Matomo?.getTracker?.()?.getVisitorInfo?.());
        if (Array.isArray(info) && info[1]) {
          return info[1];
        }
      } catch (_) {}
      return '';
    },
    getVisitorIdFromCookie() {
      try {
        const m = (document.cookie || '').match(/_pk_id\.[^=]*=([^;]+)/);
        if (m && m[1]) {
          // _pk_id cookie 形如: visitorid.XXXX.XXXX... 取第一段
          const val = decodeURIComponent(m[1]);
          const first = (val || '').split('.').shift();
          return first || '';
        }
      } catch (_) {}
      return '';
    },
    async resolveIdvisitorOnce() {
      // 依次尝试：Matomo API -> _pk_id Cookie
      const fromMatomo = this.getVisitorIdFromMatomo();
      if (fromMatomo) {
        this.idvisitor = fromMatomo;
        try { localStorage.setItem('kia_idvisitor', this.idvisitor); } catch (_) {}
        return this.idvisitor;
      }
      const fromCookie = this.getVisitorIdFromCookie();
      if (fromCookie) {
        this.idvisitor = fromCookie;
        try { localStorage.setItem('kia_idvisitor', this.idvisitor); } catch (_) {}
        return this.idvisitor;
      }
      return '';
    },
    startIdvisitorInit() {
      // 最多尝试 10 次，每次 300ms，避免 Matomo 脚本尚未就绪
      if (this._idvisitorInitTimer) return;
      const tryResolve = async () => {
        this._idvisitorTries += 1;
        const vid = await this.resolveIdvisitorOnce();
        if (vid || this._idvisitorTries >= 10) {
          clearInterval(this._idvisitorInitTimer);
          this._idvisitorInitTimer = null;
          return;
        }
      };
      this._idvisitorInitTimer = setInterval(tryResolve, 300);
      // 立即尝试一次
      tryResolve();
    },
    computeHasBack() {
      try {
        // 刷新场景下不显示返回
        let isReload = false;
        try {
          const navEntries = (window.performance && window.performance.getEntriesByType)
            ? window.performance.getEntriesByType('navigation')
            : [];
          if (navEntries && navEntries[0] && navEntries[0].type) {
            isReload = navEntries[0].type === 'reload';
          } else if (window.performance && window.performance.navigation) {
            // 兼容旧接口：1 表示 reload
            isReload = window.performance.navigation.type === 1;
          }
        } catch (_) { isReload = false; }

        if (isReload) {
          this.hasBack = false;
          return;
        }

        const hasHistory = !!(window.history && window.history.length > 1);
        let hasValidReferrer = false;
        try {
          const ref = document.referrer;
          if (ref) {
            const refUrl = new URL(ref, window.location.origin);
            // 与当前完全相同的 URL 视为无效来源
            hasValidReferrer = refUrl.href !== window.location.href;
          }
        } catch (_) { hasValidReferrer = false; }

        this.hasBack = hasHistory || hasValidReferrer;
      } catch (_) {
        this.hasBack = false;
      }
    },
    // 统一的自动发送入口问题逻辑
    tryAutoSendEntry() {
      try {
        if (this.hasAutoSentEntry || this.isStreaming) {
          console.log('[ChatBot] skip auto send (already sent or streaming)');
          return;
        }
        const q = (this.pendingEntryQuestion || this.getEntryQuestionFromUrl() || '').trim();
        if (!q) {
          console.log('[ChatBot] no entryQuestion found');
          return;
        }
        if (!this.noticeOk) {
          // 未同意则暂存
          this.pendingEntryQuestion = q;
          console.log('[ChatBot] notice not accepted, pending entry saved:', q);
          return;
        }
        // 已同意则自动发送一次
        this.inputText = q;
        this.hasAutoSentEntry = true;
        console.log('[ChatBot] auto sending entryQuestion:', q);
        this.$nextTick(() => this.send());
      } catch (_) {}
    },
    // 更健壮地获取 URL 中的 entryQuestion（支持 query、hash 和 vue-router）
    getEntryQuestionFromUrl() {
      try {
        const decodePlus = (s) => {
          try { return decodeURIComponent(String(s || '').replace(/\+/g, '%20')); } catch (_) { return String(s || ''); }
        };
        // 1) 优先从 vue-router 读取
        if (this.$route && this.$route.query && this.$route.query.entryQuestion) {
          return decodePlus(this.$route.query.entryQuestion);
        }
        const href = window.location.href || '';
        const url = new URL(href, window.location.origin);
        // 2) 读取 ?query
        const q1 = url.searchParams.get('entryQuestion');
        if (q1) return decodePlus(q1);
        // 3) 读取 hash 中 ?后的参数
        if (url.hash && url.hash.includes('?')) {
          const idx = url.hash.indexOf('?');
          const hashQuery = url.hash.slice(idx + 1);
          const params = new URLSearchParams(hashQuery);
          const q2 = params.get('entryQuestion');
          if (q2) return decodePlus(q2);
        }
      } catch (_) {}
      return '';
    },
    goback() {
      // 移动端：如果有弹窗打开，先关闭弹窗
      if (this.isPortrait && (this.showDealersOverlay || this.showCompareOverlay || this.showImageVideoOverlay)) {
        this.showDealersOverlay = false;
        this.showCompareOverlay = false;
        this.showImageVideoOverlay = false;
        return;
      }
      // 有历史则返回；否则根据“来源页面”判断环境跳首页
      // if (typeof window !== 'undefined' && window.history && window.history.length > 1) {
      //   window.history.back();
      //   return;
      // }
      try {
        const ref = document.referrer || '';
        let target = 'https://www.kia.cn/';
        if (ref) {
          try {
            const url = new URL(ref, window.location.origin);
            const host = (url && url.hostname) || '';
            if (host.includes('uat.kia.cn')) {
              target = 'https://uat.kia.cn/';
            } else if (host.includes('kia.cn')) {
              target = 'https://www.kia.cn/';
            }
          } catch (_) {}
        }
        window.location.replace(target);
      } catch (_) {}
    },
    // 渲染markdown内容
    renderMarkdown(text) {
      if (!text) return '';
      
      try {
        // 创建一个新的marked渲染器实例
        const renderer = new marked.Renderer();
        
        // // 重写link方法，确保所有链接在新窗口打开
        // renderer.link = function(href, title, text) {
        //   // 安全处理href属性，避免XSS攻击
        //   const safeHref = href.replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
        //   const titleAttr = title ? ` title="${title.replace(/"/g, '&quot;').replace(/'/g, '&#x27;')}"` : '';
        //   // 确保添加完整的target和rel属性，并添加onclick事件作为额外保障
        //   return `<a href="${safeHref}" target="_blank" rel="noopener noreferrer"${titleAttr} onclick="event.preventDefault(); window.open(this.href, '_blank', 'noopener,noreferrer');">${text}</a>`;
        // };
        
        // 设置marked选项
        marked.setOptions({
          renderer: renderer,
          breaks: true, // 支持换行
          gfm: true, // 支持GitHub风格markdown
          sanitize: false, // 允许HTML标签
          html: true // 启用HTML标签解析
        });
        
        // 直接使用marked渲染Markdown
        let html = marked(text);
        
        // // 额外的安全检查和修复：确保所有<a>标签都有正确的target属性
        // const tempDiv = document.createElement('div');
        // tempDiv.innerHTML = html;
        // const links = tempDiv.querySelectorAll('a');
        // links.forEach(link => {
        //   // 只在链接没有target属性时添加
        //   if (!link.hasAttribute('target')) {
        //     link.setAttribute('target', '_blank');
        //   }
        //   // 只在链接没有rel属性时添加
        //   if (!link.hasAttribute('rel')) {
        //     link.setAttribute('rel', 'noopener noreferrer');
        //   }
        //   // 确保有onclick事件处理
        //   if (!link.hasAttribute('onclick')) {
        //     link.setAttribute('onclick', "event.preventDefault(); window.open(this.href, '_blank', 'noopener,noreferrer');");
        //   }
        // });

         // 确保HTML列表标签正确包装
        // 查找所有未被<ul>或<ol>包裹的<li>标签
        const looseListItems = tempDiv.querySelectorAll('li:not(ul li):not(ol li)');
        if (looseListItems.length > 0) {
          // 创建一个临时容器来重组HTML结构
          const container = document.createElement('div');
          let currentHtml = tempDiv.innerHTML;
          
          // 找出所有<li>标签的位置并包装它们
          let lastEnd = 0;
          let listItems = [];
          let match;
          const liRegex = /<li[^>]*>.*?<\/li>/gs;
          
          while ((match = liRegex.exec(text)) !== null) {
            listItems.push({ start: match.index, end: match.index + match[0].length, content: match[0] });
          }
          
          // 合并连续的<li>标签并包装在<ul>中
          if (listItems.length > 0) {
            let i = 0;
            while (i < listItems.length) {
              let j = i;
              // 查找连续的<li>标签
              while (j + 1 < listItems.length && listItems[j + 1].start <= listItems[j].end + 10) { // 允许一些空白字符
                j++;
              }
              
              // 添加前面的非列表内容
              container.innerHTML += text.substring(lastEnd, listItems[i].start);
              
              // 包装连续的<li>标签在<ul>中
              container.innerHTML += '<ul>';
              for (let k = i; k <= j; k++) {
                container.innerHTML += listItems[k].content;
              }
              container.innerHTML += '</ul>';
              
              lastEnd = listItems[j].end;
              i = j + 1;
            }
            
            // 添加剩余的内容
            container.innerHTML += text.substring(lastEnd);
            return container.innerHTML;
          }
        }
        
        // return tempDiv.innerHTML;
        // 在返回前将<br>替换为空格
        let finalHtml = tempDiv.innerHTML;
        finalHtml = finalHtml.replace(/<br\s*\/?>/gi, ' ');
        return finalHtml;
      } catch (e) {
        console.warn('Markdown渲染失败:', e);
        // 失败时的备用方案
        try {
          let result = text;
          
          // // 处理直接URL链接 - 首先检查是否已经是链接
          // const urlRegex = /(https?:\/\/[\w\-._~:/?#[\]@!$&'()*+,;=%]+)/gi;
          // result = result.replace(urlRegex, (match, url) => {
          //   // 检查这个URL是否已经在<a>标签内
          //   if (/<a[^>]*href=["']?\s*\bhttps?:\/\/[^"'>\s]+["']?[^>]*>/i.test(result)) {
          //     return match;
          //   }
          //   return `<a href="${url}" target="_blank" rel="noopener noreferrer" onclick="event.preventDefault(); window.open(this.href, \'_blank\', \'noopener,noreferrer\');">${url}</a>`;
          // });
          
          // // 处理Markdown格式链接
          // const mdLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
          // result = result.replace(mdLinkRegex, (match, text, href) => {
          //   // 安全处理href属性
          //   const safeHref = href.replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
          //   return `<a href="${safeHref}" target="_blank" rel="noopener noreferrer" onclick="event.preventDefault(); window.open(this.href, \'_blank\', \'noopener,noreferrer\');">${text}</a>`;
          // });

          // 处理HTML列表标签 - 确保<li>标签被<ul>包裹
          // 先检查是否已经有包裹，如果没有则添加
          if (result.includes('<li>') && !result.includes('<ul>')) {
            result = result.replace(/(<li>.*?<\/li>)/gs, '<ul>$1</ul>');
          }
          // 基本格式处理
          result = result.replace(/^### (.*$)/gm, '<h3>$1</h3>');
          result = result.replace(/^## (.*$)/gm, '<h2>$1</h2>');
          result = result.replace(/^# (.*$)/gm, '<h1>$1</h1>');
          result = result.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
          result = result.replace(/\*(.*?)\*/g, '<em>$1</em>');
          // result = result.replace(/\n/g, '<br>');
          result = result.replace(/\n+/g, '<br>');
          result = result.replace(/^- (.*$)/gm, '<li>$1</li>');
          result = result.replace(/(<li>[^<]*<\/li>\s*)+/g, '<ul>$&</ul>');

          // 在返回前将所有<br>替换为空格
          result = result.replace(/<br\s*\/?>/gi, ' ');
          
          return result;
        } catch (fallbackError) {
          // 最终兜底：使用textContent确保安全
          const tempDiv = document.createElement('div');
          tempDiv.textContent = text;
          return tempDiv.innerHTML;
        }
      }
    },
    // 2. 重写setResize方法，专注于设置固定高度布局
    setResize() {
      this.isPortrait = isPortraitFun();
      this.$nextTick(() => {
        this.computeMobHeaderHeight();
        // 对于百度浏览器，应用特殊的固定高度布局
        if (this.detectSpecialBrowsers() && this.isPortrait) {
          this.setupFixedLayout();
        } else {
          // 移除可能干扰的监听器
          this.removeMobileTouchListeners();
          this.addMobileTouchListeners();
        }
      });
    },
    // 添加新方法设置固定高度布局  
    setupFixedLayout() {
      const chatPanel = this.$el.querySelector('.chat-panel');
      const chatBody = this.$el.querySelector('.chat-body');
      const chatFooter = this.$el.querySelector('.chat-footer');
      const mobHeader = this.$el.querySelector('.mob-chat-header');
      
      if (chatPanel && chatBody && chatFooter && mobHeader) {
        // 清除所有可能干扰的样式
        chatPanel.style.cssText = '';
        chatBody.style.cssText = '';
        chatFooter.style.cssText = '';
        mobHeader.style.cssText = ''; 
        // 设置基础布局样式
        const windowHeight = window.innerHeight;
        const layoutHeight = windowHeight; 
        
        Object.assign(chatPanel.style, {
          height: `${layoutHeight}px`,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          zIndex: '1000',
          // 添加!important以确保优先级
          boxSizing: 'border-box !important'
        });
        
        // 设置头部高度并固定
        const headerHeight = this.mobHeaderHeight || mobHeader.offsetHeight;
        Object.assign(mobHeader.style, {
          height: `${headerHeight}px`,
          position: 'relative',
          flexShrink: '0',
          zIndex: '10'
        });
        
        // 获取底部高度并固定在底部
        const footerHeight = chatFooter.offsetHeight;
        Object.assign(chatFooter.style, {
          height: `${footerHeight}px`,
          position: 'relative',
          flexShrink: '0',
          marginTop: 'auto', // 确保底部区域始终在底部
          zIndex: '10'
        });
        
        // 计算并设置聊天内容区域的高度
        const bodyHeight = layoutHeight - headerHeight - footerHeight;
        Object.assign(chatBody.style, {
          height: `${Math.max(bodyHeight, 200)}px`,
          overflowY: 'auto',
          flexGrow: '1',
          flexShrink: '0',
          position: 'relative',
          WebkitOverflowScrolling: 'touch',
          touchAction: 'pan-y',
          WebkitTransform: 'translateZ(0)',
          transform: 'translateZ(0)',
          willChange: 'transform'
        });
        
        // 立即应用布局更改并滚动到底部
        this.$nextTick(() => {
          this.scrollToBottom(true);
        });
      }
    },
    computeMobHeaderHeight() {
      try {
        if (!this.isPortrait) {
          this.mobHeaderHeight = 0;
          return;
        }
        const header = this.$el && this.$el.querySelector('.mob-chat-header');
        this.mobHeaderHeight = header ? header.offsetHeight : 0;
      } catch (_) {
        this.mobHeaderHeight = 0;
      }
    },
    onPanelTouchMove(e) {
      console.log('onPanelTouchMove', e);
      // 对于百度浏览器，完全不阻止任何滚动行为
      if (this.detectSpecialBrowsers()) {
        return;
      }
      // 移动端：在头部或底部触摸移动时阻止页面滚动
      if (this.isPortrait) {
        // 重要：获取事件目标并确定滚动区域
        const target = e.target;
        const isInChatBody = target.closest('.chat-body');
        // 对于聊天内容区域，完全允许默认滚动行为
        if (isInChatBody) {
          // 确保不会阻止聊天内容区域的滚动
          return;
        }
        // 只在特定非滚动区域才考虑阻止默认行为
        const isInHeader = target.closest('.mob-chat-header');
        const isInFooter = target.closest('.chat-footer');
        const isInDealersHeader = target.closest('.dealers-header-mob');
        const isInCompareHeader = target.closest('.compare-header-mob');
        if (isInHeader || isInFooter || isInDealersHeader || isInCompareHeader) {
          // 1. 添加cancelable检查，避免在不支持的环境中报错
          // 2. 使用try-catch包装，增强兼容性
          try {
            if (e.cancelable) {
              // 对于百度浏览器和荣耀自带浏览器，使用passive: false来确保preventDefault生效
              e.preventDefault();
            }
          } catch (err) {
            console.warn('触摸事件处理错误:', err);
          }
          return;
        }
      }
    },
    // 去除HTML标签（用于日志入参）
    stripHtml(text) {
      try {
        const div = document.createElement('div');
        div.innerHTML = text || '';
        return div.textContent || div.innerText || '';
      } catch (_) {
        return String(text || '').replace(/<[^>]+>/g, '');
      }
    },
    initDealerUrl() {
      const href = window.location.href || '';
      if (href.includes('uat.kia.cn')) {
        this.dealerUrl = 'https://uat.kia.cn/dealer/';
      } else if (href.includes('www.kia.cn') || href.includes('kia.cn')) {
        this.dealerUrl = 'https://www.kia.cn/dealer/';
      } else {
        this.dealerUrl = 'https://uat.kia.cn/dealer/';
      }
    },
    // 获取欢迎推荐问题池
    async fetchRecommendedPool() {
      var that = this
      try {
        // 从后端“推荐问题管理”获取推荐问题池
        const res = await this.$axios.get(`${aiUrl}api/intellSearchEntry/client/getAllRecommendations`, {
          headers: {
            token: this.token,
          },
        });
        this.welcomeMessage = res.data.data.welcomeMessage;
        const data = (res && res.data && res.data.data) || {};
        const welcomeQuestions = Array.isArray(data.welcomeQuestions) ? data.welcomeQuestions : [];
        const list = welcomeQuestions.reduce((acc, item) => {
          const arr = item && Array.isArray(item.questionList) ? item.questionList : [];
          return acc.concat(arr);
        }, []);
        this.recommendedPool = list;
      } catch (e) {
        // 兜底静态文案（不同场景）
        this.recommendedPool = [
          'EV5 的续航里程是多少？',
          '近期是否有优惠活动？',
          '如何预约试驾？',
          '售后保养政策是怎样的？',
          '如何选择合适的车型？',
          '金融分期有哪些方案？',
          '现在下订什么时候能提车？'
        ];
      } finally {
        this.shuffleRecommendations();
      }
    },
    // 洗牌算法 
    shuffleRecommendations() {
      const pool = [...this.recommendedPool];
      const picked = [];
      // 抽取 3 个不同的问题
      for (let i = 0; i < 3 && pool.length > 0; i++) {
        const idx = Math.floor(Math.random() * pool.length);
        picked.push(pool[idx]);
        pool.splice(idx, 1);
      }
      this.recommendations = picked;
    },
    spinAndShuffle() {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '机器人聊天-灰色聊天框右下角-点击‘切换问题图标’按钮', 1]);
      stm_clicki("send",'event',window.location.href, "点击", '机器人聊天-灰色聊天框右下角-点击‘切换问题图标’按钮');
      if (this.isChangeSpinning) return;
      this.isChangeSpinning = true;
      this.isRecommendationsLoading = true; // 开始加载
      
      // 先清空推荐列表显示加载状态
      const oldRecommendations = [...this.recommendations];
      this.recommendations = ['', '', '']; // 显示3个加载占位符
      
      setTimeout(() => {
        this.shuffleRecommendations();
        this.isChangeSpinning = false;
        this.isRecommendationsLoading = false; // 加载完成
      }, 600);
    },
    // 新增方法：过滤危险HTML标签和属性
    sanitizeInput(input) {debugger
        // 创建一个临时div元素来解析HTML
        const temp = document.createElement('div');
        temp.textContent = input; // 使用textContent而不是innerHTML来避免解析HTML
        
        // 获取纯文本内容
        let safeText = temp.textContent || temp.innerText || '';
        
        // 移除所有HTML标签
        safeText = safeText.replace(/<[^>]+>/g, '');
        
        // 检查是否包含HTML标签
        const hasHtml = /<[^>]+>/.test(input);
        if (hasHtml) {
            // 如果包含HTML标签，返回空字符串并提示
            this.$message.warning('不支持HTML格式输入');
            this.inputText = ''; // 新增：清空输入框内容
            return '';
        }
        
        // 可选：保留一些安全的格式标记（如换行符）
        safeText = safeText.replace(/\n/g, '<br>');
        
        return safeText;
    },
    handlePickQuestion(q) { 
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '机器人聊天-推荐问题：'+ q, 1]);
      stm_clicki("send",'event',window.location.href, "点击", '机器人聊天-推荐问题：'+ q);
       // 安全处理问题
      const safeQ = this.sanitizeInput(q);
      this.inputText = safeQ;
      // 用户点击推荐问题时，重置滚动状态
      this.userScrolling = false;
      this.send();
    },
    // 获取问题类型的方法
    async getQuestionType(question) {
      const that = this
      try {
        const formData = new FormData();
        formData.append('question', question);
        formData.append('taskId', '1914211815315750917');
        formData.append('uuid', this.currentUuid);
        
        const res = await this.$axios.post(
          `${aiUrl}keyword/searchCssJqType`,
          formData,
          {
            headers: {
              token: that.token,
            },
          }
        );
        if (res.data.data && res.data.code == 200) {
          return res.data.data;
        }
      } catch (searchError) {
        console.warn('searchCss 接口调用失败，使用默认类型:', searchError);
      }
      return '';
    },
    // 获取问题增强结果（问句增强）
    async getEnhancedQuestion(question) {
      const that = this
      try {
        const formData = new FormData();
        formData.append('question', question);
        formData.append('taskId', '1914211815315750917');
        formData.append('uuid', this.currentUuid);
        const res = await this.$axios.post(
          `${aiUrl}keyword/askZengQiang`,
          formData,
          {
            headers: {
              token: that.token,
            },
          }
        );
        // 期望后端返回增强后的问句字符串或包含在 data 中
        if (res && res.data) {
          if (typeof res.data === 'string') return res.data;
          if (res.data.data && typeof res.data.data === 'string') return res.data.data;
          if (res.data.data && res.data.data.enhanced) return res.data.data.enhanced;
        }
      } catch (e) {
        console.warn('askZengQiang 接口调用失败，跳过增强:', e);
      }
      return '';
    },
    //发送问题
    async send() {  
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '机器人聊天-底部-点击‘发送’按钮', 1]);
      stm_clicki("send",'event',window.location.href, "点击", '机器人聊天-底部-点击‘发送’按钮');
      // 发送前再确保尝试获取一次 idvisitor（避免偶发空值）
      if (!this.idvisitor) {
        await this.resolveIdvisitorOnce();
      }
      var that = this
      const text = this.sanitizeInput((this.inputText || '').trim());//(this.inputText || '').trim();
      if (!text || this.isStreaming) return;
      // 用户消息
      this.messages.push({ role: 'user', text });
      const question = text;
       this. questionSendText = text;
      this.inputText = '';
      // 用户发送新消息时，重置滚动状态
      this.userScrolling = false;
      // 立即创建AI回复消息，实现思考动画即时显示
      const botMsg = {
        role: 'assistant',
        text: '',
        questionType: '', // 稍后更新
        isExtractSuccess: '', // 稍后更新
        showDisclaimer: false,
        suggestions: [],
        showSuggestions: false
      };
      
      // 立即添加到对话列表
      this.messages.push(botMsg);
      this.$nextTick(() => this.scrollToBottom(true));
      
      try {
        this.isStreaming = true;
        
        // 并行调用：问题类型识别 + 问句增强
        var [questionType, enhancedQuestion] = await Promise.all([
          this.getQuestionType(question),
          this.getEnhancedQuestion(question),
        ]);
        
        // 调用 keyword/answer 接口获取回答
        const formData = new FormData();
        formData.append('question', question);
        formData.append('taskId', '1914211815315750917');
        formData.append('type', questionType);
        formData.append('uuid', this.currentUuid);
        // 将增强问句一并传给后端（后端可选读取）
        if (enhancedQuestion) {
          formData.append('questionZengQiang', enhancedQuestion);
        }
        // 添加经纬度参数
        console.log('发送消息时的 clientPosition:', this.clientPosition);
        console.log('发送消息时的 defaultClientPosition:', this.defaultClientPosition);
        const position = this.clientPosition || this.defaultClientPosition;
        console.log('最终使用的 position:', position);
        if (position && position.lng && position.lat) {
          formData.append('lng', position.lng.toString());
          formData.append('lat', position.lat.toString());
          console.log('已添加经纬度到请求:', { lng: position.lng, lat: position.lat });
        } else {
          console.warn('未找到有效的经纬度信息');
        }
        
        const res = await this.$axios.post(
          `${aiUrl}keyword/answerJSON`,
          formData,
          {
            headers: {
              token: that.token,
              idvisitor: that.idvisitor || that.currentUuid || 'anonymous',
            },
          }
        );
        this.questionType4ChangeViewFlg = questionType;
        // 添加viewFlg处理逻辑 - 只处理活动状态为5的情况
        let viewFlg = res.data.data && res.data.data.viewFlg ? res.data.data.viewFlg : '1';
        // 活动状态为5时的特殊处理
        if (questionType === '5') {
          if (viewFlg === '2') { 
            questionType = '9';
          } else if (viewFlg === '3') { 
            questionType = '-1';
          } 
        }
        
        // 创建AI回复消息（初始为空，用于流式填充）
        // const botMsg = {
        //   role: 'assistant',
        //   text: '',
        //   questionType: questionType,
        //   isExtractSuccess: res.data.data.isExtractSuccess,
        //   showDisclaimer: false, // 初始不显示免责声明
        //   suggestions: [],
        //   showSuggestions: false // 初始不显示建议
        // };
        
        // // 添加消息到对话列表
        // this.messages.push(botMsg);
        // 更新已存在的botMsg的属性
        botMsg.questionType = questionType;
        botMsg.isExtractSuccess = res.data.data.isExtractSuccess;
        
        // 预先获取建议问题，但不显示
        this.fetchSuggestionsFor(question, botMsg, questionType);
        
        // 滚动到底部
        this.$nextTick(() => this.scrollToBottom(true));
        
        // 调用 keyword/chat/stream 接口处理EventStream
        // 构建查询参数
        const params = new URLSearchParams();
        // 将answerJSON返回的参数传递给stream接口
        var prompt='';
        var taskId='1914211815315750917'
        var uuid = this.currentUuid
        if (res.data.data && res.data.data.prompt) {
          prompt=res.data.data.prompt
          params.append('prompt', prompt);
        }
        if (res.data.data && res.data.data.taskId) {
          taskId=res.data.data.taskId
          params.append('taskId', taskId);
        }
        if (res.data.data && res.data.data.uuid) {
          uuid = res.data.data.uuid
          params.append('uuid', uuid);
        }
        // 根据 answer 内容决定传递给 stream 的 type 值
        const answerText = (res && res.data && res.data.data && res.data.data.answer) || '';
        let streamType = 1;
        if (typeof answerText === 'string') {
          if (answerText.includes('type传0')) {
            streamType = 0;
          } else if (answerText.includes('type传1')) {
            streamType = 1;
          }
        }
        params.append('type', streamType);
      
        
      //不同 type 传参不同
      var sendJson
      if (streamType === 0) {
        sendJson = {
          "model": "deepseek-v3",
          "stream": true,
          "messages": [
            {
                "role": "system",
                "content": "#角色\n 文字输出器 #目标\n 请严格输出用户输入的文本内容、不要进行任何修改、解释或额外内容. #注意:务必不要缺少或新增任何一个字。"
            },
            {
                "role": "user",
                "content": prompt
            }
          ]
        }
      }else if (streamType === 1) {
        sendJson = {
          "model": "deepseek-v3",
          "stream": true,
          "messages": [
            {
                "role": "system",
                "content": prompt + "\n\n#注意:请用Markdown格式回答(美化下返回内容格式,只加标题<h1><h2><h3><h4>、粗体<strong>、斜体<em>、换行符<br>、列表<ul><li>，，禁止使用 Markdown 链接语法（如 [text](url)）。任何时候需要提供起亚中国官网链接，不要输出裸露的纯文本 URL（如 https:\/\/www.kia.cn）。必须使用以下标准 HTML 链接格式：<a href= \"https://www.kia.cn\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.kia.cn</a >若需指向具体页面（如品牌、车型等），可将 href 替换为完整路径（如 https://www.kia.cn/brand/），但链接文字仍显示完整URL。"
            },
            {
                "role": "user",
                "content": question
            }
          ]
        }
      }
      
      // 使用阿里云API进行流式对话（动态获取10分钟有效的密钥，失败自动刷新重试一次）
      const doRequest = async (retry) => {
        const { getAliyunBearer, invalidateAliyunBearer } = await import('@/utils/aliyunToken.js');
        let auth = await getAliyunBearer(retry === true);
        
        return fetch('https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': auth
          },
          body: JSON.stringify(sendJson)
        }).then(async (response) => {
          if (response.status === 401 || response.status === 403) {
            // token 失效，刷新后重试一次
            if (!retry) {
              invalidateAliyunBearer();
              return doRequest(true);
            }
          }
          return response;
        })
      }

      doRequest(false)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        
        const readStream = () => {
          reader.read().then(({ done, value }) => {
            if (done) {
              console.log('Stream completed');
              // 流式输出完成后显示免责声明和建议
              botMsg.showDisclaimer = true;
              botMsg.showSuggestions = true;  
                // 显示建议后滚动到底部，延迟等待推荐问题加载
             
                this.$nextTick(() => {
                setTimeout(() => {
                
                  if(!this.userScrolling){
                   
                    this.scrollToBottom(true);
                  }
                  
                }, 200);
              });
              // 流式对话完成后，调用用户日志接口
              this.addUserLog(this.stripHtml(botMsg.text), taskId, uuid);
                // 新增：标记机器人已说完话
              if (botMsg.questionType === '4' && botMsg.questionType4Data) {
                botMsg.questionType4Data.isBotFinishedSpeaking = true;
                console.log('机器人已说完话，标记问题类型4的数据'); 
              }
              // 新增：处理other类型的问题
              if (this.currentQuestionType === '9' && !this.isPortrait && this.currentNormalized) {
                // 加强关键词检测，确保机器人回复不包含无法回答的标识
                const botResponse = this.stripHtml(botMsg.text);
                // 使用更全面的关键词检测，包括中英文和不同表达方式
                const containsUnavailableResponse = 
                  botResponse.includes('抱歉') || 
                  botResponse.includes('卡壳');
                  
                console.log('机器人回复检测:', { botResponse, containsUnavailableResponse });
                
                // 只有当不包含无法回答的关键词时才触发emit
                if (!containsUnavailableResponse) {
                  this.$emit('change-left-part', 'other', this.currentNormalized,questionType,enhancedQuestion);
                }
                // 重置当前问题类型和参数
                this.currentQuestionType = null;
                this.currentNormalized = null;
              }
            
              return;
            }
            
            const chunk = decoder.decode(value, { stream: true });
            const lines = chunk.split('\n');
            
            for (const line of lines) {
              const trimmedLine = line.trim();
              if (!trimmedLine || !trimmedLine.startsWith('data: ')) continue;
              
              const data = trimmedLine.slice(6); // 移除 'data: ' 前缀
              if (data === '[DONE]') {
                console.log('Stream completed');
                // 流式输出完成后显示免责声明和建议
                botMsg.showDisclaimer = true;
                botMsg.showSuggestions = true;
                // 流式对话完成后，调用用户日志接口
                this.addUserLog(this.stripHtml(botMsg.text), taskId, uuid);
                // 新增：标记机器人已说完话
                if (botMsg.questionType === '4' && botMsg.questionType4Data) {
                  botMsg.questionType4Data.isBotFinishedSpeaking = true;
                  console.log('机器人已说完话，标记问题类型4的数据');
                }
                // 新增：处理other类型的问题
                if (this.currentQuestionType === '9' && !this.isPortrait && this.currentNormalized) {
                  // 加强关键词检测，确保机器人回复不包含无法回答的标识
                  const botResponse = this.stripHtml(botMsg.text);
                  // 使用更全面的关键词检测，包括中英文和不同表达方式
                  const containsUnavailableResponse = 
                    botResponse.includes('抱歉') || 
                    botResponse.includes('卡壳');
                    
                  console.log('机器人回复检测:', { botResponse, containsUnavailableResponse });
                  
                  // 只有当不包含无法回答的关键词时才触发emit
                  if (!containsUnavailableResponse) {
                    this.$emit('change-left-part', 'other', this.currentNormalized,questionType,enhancedQuestion);
                  }
                  // 重置当前问题类型和参数
                  this.currentQuestionType = null;
                  this.currentNormalized = null;
                }
                // 显示建议后滚动到底部，延迟等待推荐问题加载
                this.$nextTick(() => {
                  setTimeout(() => {
                    if(!this.userScrolling){
                   
                   this.scrollToBottom(true);
                 }
                  }, 200);
                });
                return;
              }
              
              try {
                const jsonData = JSON.parse(data);
                if (jsonData.choices && jsonData.choices[0] && jsonData.choices[0].delta && jsonData.choices[0].delta.content) {
                  const content = jsonData.choices[0].delta.content;
                  botMsg.text += content;
                  this.$nextTick(() => this.scrollToBottom(false));
                }
              } catch (parseError) {
                console.warn('Failed to parse stream data:', parseError);
              }
            }
            
            // 继续读取流
            readStream();
          }).catch(error => {
            console.warn('Stream read error:', error);
          });
        };
        
        // 开始读取流
        readStream();
      })
      .catch(streamError => {
        console.warn('阿里云API调用失败:', streamError);
        // 如果stream失败，使用默认回答
        botMsg.text = streamError.response.data.msg;
        // 即使失败也显示免责声明和建议
        botMsg.showDisclaimer = true;
        botMsg.showSuggestions = true;
        // 显示建议后滚动到底部，延迟等待推荐问题加载
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToBottom(false);
          }, 200);
        });
      });  
        //经销商类型 && isExtractSuccess == ‘1’  pc：左边展示经销商列表 mob：展示经销商按钮
        if (questionType === '3' && res.data.data.isExtractSuccess == '1') {
          // 记录经销商查询参数（字符串转数组）
          const rawDealer = (res.data && res.data.data && res.data.data.result) ? res.data.data.result : '';
          const normalized = JSON.parse(rawDealer);
          // const normalized = rawDealer;
          this.dealerQuestion = normalized;
          // PC端：通知父组件切换左侧面板为经销商并传参
          if (!this.isPortrait) {
            this.$emit('change-left-part', 'dealers', normalized);
          }
        }
        //车型对比类型 && isExtractSuccess == ‘1’  pc：左边展示车型对比列表 mob：展示车型对比按钮
        else if (questionType === '2' && res.data.data.isExtractSuccess == '1') {
          // 记录对比问题参数（数组转字符串）
          const rawResult = (res.data && res.data.data && res.data.data.result) ? res.data.data.result : '';
          const normalized = Array.isArray(rawResult)
            ? JSON.stringify(rawResult)
            : (typeof rawResult === 'string' ? rawResult : String(rawResult || ''));
          this.compareQuestion = normalized;
          // PC端：通知父组件切换左侧面板为车型对比并传参
          if (!this.isPortrait) {
            this.$emit('change-left-part', 'compare', normalized);
          }
        }
        
        //3.0 增加品牌服务场景
        else if (questionType === '8' ) {
          // 记录品牌服务场景问题参数
          const rawResult = (res.data && res.data.data && res.data.data.result) ? res.data.data.result : '';
          // const normalized = Array.isArray(rawResult)
          //   ? JSON.stringify(rawResult)
          //   : (typeof rawResult === 'string' ? rawResult : String(rawResult || ''));
          const normalized = this.questionSendText; 
          this.brandServiceQuestion = normalized;
       
          // PC端：通知父组件切换左侧面板为品牌服务场景并传参
          
          if (!this.isPortrait) {
            this.$emit('change-left-part', 'service', normalized);
          }
        }
        //4.0 增加其他问题提问场景
        else if (questionType === '9' ) {
          // 记录品牌服务场景问题参数
          const rawResult = (res.data && res.data.data && res.data.data.result) ? res.data.data.result : '';
          // const normalized = Array.isArray(rawResult)
          //   ? JSON.stringify(rawResult)
          //   : (typeof rawResult === 'string' ? rawResult : String(rawResult || ''));
          const normalized = this.questionSendText; 
          this.brandOtherQuestion = normalized;

           // 存储问题类型和参数，等待流式对话完成后处理
          // this.currentQuestionType = questionType;
          // this.currentNormalized = normalized;
       
          // PC端：通知父组件切换左侧面板为品牌服务场景并传参      
          if (!this.isPortrait) {
            this.$emit('change-left-part', 'other', normalized,questionType,enhancedQuestion);
          }
        } 
        // 新增：问题类型为4时的特殊处理
        else if (questionType === '4' && res.data.data.isExtractSuccess == '1') {
          // 记录原始车型数组数据
          const rawResult = (res.data && res.data.data && res.data.data.result) ? res.data.data.result : [];
          const normalized = Array.isArray(rawResult)
              ? JSON.stringify(rawResult)
              : (typeof rawResult === 'string' ? rawResult : String(rawResult || ''));
          
          // 不立即调用多模态展示，而是存储相关参数
          this.$nextTick(() => {
            // 获取最新添加的botMsg
            const currentBotMsg = this.messages[this.messages.length - 1];
            // 为botMsg添加额外属性，用于后续处理
            currentBotMsg.questionType4Data = {
              originalResult: normalized,
              enhancedQuestion: enhancedQuestion,
              isProcessing: true, // 标记正在处理中
              isBotFinishedSpeaking: false // 标记机器人是否已说完话
            };
            
            // 存储botMsg引用，便于后续检查
            this.currentType4BotMsg = currentBotMsg;
            
            // 重要修改：在机器人开始说话时就启动监测，而不是等说话完成
            this.processQuestionType4(currentBotMsg);
          });
        }
        else if (questionType !== '3' && questionType !== '2' && questionType !== '8' && questionType !== '9' && questionType !== '7' && questionType !== '4' && parseInt(questionType) < 9 && res.data.data.isExtractSuccess == '1') {
          //剩下的全是多模态 -> PC端通知父组件切换为 details
          const rawResult = (res.data && res.data.data && res.data.data.result) ? res.data.data.result : '';
          const normalized = Array.isArray(rawResult)
              ? JSON.stringify(rawResult)
              : (typeof rawResult === 'string' ? rawResult : String(rawResult || ''));
          if (!this.isPortrait) {
            // 记录多模态问题参数 
            this.$emit('change-left-part', 'details', normalized,questionType,enhancedQuestion);
          } else {
            // 移动端：通知父组件切换为详情页并传参
            this.imageVideoQuestion = normalized;
            this.imageVideoQuestionType = questionType;
            this.imageVideoEnhancedQuestionQuestion = enhancedQuestion;
          }
        }

        
      } catch (error) {
        console.error('AI接口调用失败:', error);
        // 错误处理：显示默认回复
        const botMsg = {
          role: 'assistant',
          text: error.response.data.msg,
          showDisclaimer: true,
          suggestions: [],
          showSuggestions: true
        };
        this.messages.push(botMsg);
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToBottom(false);
          }, 200);
        });
      } finally {
        this.isStreaming = false;
      }
    },
    
    async fetchSuggestionsFor(question, targetMsg, questionType) {
      var that = this; 
              try {
          this.$set(targetMsg, 'suggestionsLoading', true);
          const formData = new FormData();
          formData.append('question', question);
          formData.append('type', this.questionType4ChangeViewFlg && this.questionType4ChangeViewFlg === '5' ? '5' : questionType); 
          const res = await this.$axios.post(`${aiUrl}keyword/recommendQuestion`, formData, {
            headers: {
              token: that.token,
            },
          });
          const list = (res && res.data && (res.data.data || res.data.suggestions)) || [];
          const arr = Array.isArray(list) ? list.slice(0, 3) : [];
        if (arr.length) {
          this.$set(targetMsg, 'suggestions', arr);
          this.$set(targetMsg, 'suggestionsLoading', false);
          this.$nextTick(() => this.scrollToBottom(false));
          return;
        }
      } catch (e) {}
      // 兜底：从推荐池随机3条
      const pool = [...this.recommendedPool];
      const picked = [];
      for (let i = 0; i < 3 && pool.length > 0; i++) {
        const idx = Math.floor(Math.random() * pool.length);
        picked.push(pool[idx]);
        pool.splice(idx, 1);
      }
      this.$set(targetMsg, 'suggestions', picked);
      this.$set(targetMsg, 'suggestionsLoading', false);
      this.$nextTick(() => this.scrollToBottom(false));
    },
    newChat() {
      // 移动端：如果有弹窗打开，先关闭弹窗
      if (this.isPortrait && (this.showDealersOverlay || this.showCompareOverlay || this.showImageVideoOverlay)) {
        this.showDealersOverlay = false;
        this.showCompareOverlay = false;
        this.showImageVideoOverlay = false;
      }
      // 生成新的UUID
      this.generateNewUuid();
      // 清空对话并重置状态
      this.messages = [];
      this.shuffleRecommendations();
      // 重置并重启动画
      this.welcomeAppearIndex = 0;
      this.welcomeSequenceStarted = false;
      this.robotTypedText = '';
      this.$nextTick(() => {
        this.startTypewriter();
        // 立即触发一次欢迎区动画（若推荐尚未就绪，watch 后续会补齐）
        this.startWelcomeSequence();
        this.scrollToBottom();
      });
      this.isStreaming = false;
    },
    scrollToBottom(force = false) {
      try {
        const el = this.$refs.chatBody;
        if (el) {
          // 如果用户正在查看历史消息，完全禁用自动滚动
          if (this.userScrolling) {
            return;
          }
          
          if (force) {
            // 强制滚动到底部
            el.scrollTop = el.scrollHeight;
          } else {
            // 计算当前滚动位置与底部的距离
            const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
            // 只有当距离底部在50px内时，才自动滚动到底部
            // 这样用户向上滑动超过50px后，就不会被强制拉回底部
            if (distanceToBottom < 50) {
              el.scrollTop = el.scrollHeight;
            }
          }
        }
      } catch (e) {}
    },
    goDealer() {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '机器人聊天-底部-点击‘经销商查询’按钮', 1]);
      stm_clicki("send",'event',window.location.href, "点击", '机器人聊天-底部-点击‘经销商查询’按钮');
        const a = document.createElement('a');
        a.href = this.dealerUrl;
        a.target = '_blank';
        a.rel = 'noopener';
        a.click();
    },
    toggleForm() {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '机器人聊天-底部-点击‘预约试驾’按钮', 1]);
      stm_clicki("send",'event',window.location.href, "点击", '机器人聊天-底部-点击‘预约试驾’按钮');
      this.showForm = true;
    },
    handleCloseForm() {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '机器人聊天-底部-预约试驾-收起', 1]);
      stm_clicki("send",'event',window.location.href, "点击", '机器人聊天-底部-预约试驾-收起');
      this.isClosing = true;
      setTimeout(() => {
        this.showForm = false;
        this.isClosing = false;
      }, 250); // 动画时长
    },
    handleDealerClick() {
      // 移动端：打开经销商弹窗；PC：保持现状
      if (this.isPortrait) {
        this.showDealersOverlay = true;
        this.$nextTick(this.computeMobHeaderHeight);
      }
      this.$emit('dealer-click');
    },
    closeDealersOverlay() {
      this.showDealersOverlay = false;
    },
    handleCompareClick() {
      // 移动端：打开车型对比弹窗；PC：保持现状
      if (this.isPortrait) {
        this.showCompareOverlay = true;
        this.$nextTick(this.computeMobHeaderHeight);
      }
      this.$emit('compare-click');
    },
    handleImageVideoClick() {
      // 移动端：打开车型对比弹窗；PC：保持现状
      if (this.isPortrait) {
        this.showImageVideoOverlay = true;
        this.$nextTick(this.computeMobHeaderHeight);
      }
      this.$emit('image-video-click');
    }, 

    addMobileTouchListeners() {
      // 对于百度浏览器，不添加任何可能干扰的监听器
      if (this.detectSpecialBrowsers()) {
        return;
      }
      if (this.isPortrait) {
        const header = this.$el.querySelector('.mob-chat-header');
        const footer = this.$el.querySelector('.chat-footer');
        const chatBody = this.$el.querySelector('.chat-body');
        if (header) {
          // header.addEventListener('touchstart', this.preventScroll);
          // 移除之前可能阻止点击的touchstart监听器
          header.removeEventListener('touchstart', this.preventScroll);
          // 只保留touchmove监听器，并设置passive: false确保preventDefault生效
          header.addEventListener('touchmove', this.preventScroll);
        }
        // if (footer) {
        //   // 不拦截触摸开始事件，避免阻止输入框获取焦点
        //   footer.addEventListener('touchmove', this.preventScroll);
        // }
        if (footer) {
          // 设置passive: false确保preventDefault在安卓浏览器中生效
          footer.addEventListener('touchmove', this.preventScroll, { passive: false });
        }
        // 为聊天内容区域添加明确的滚动支持
        if (chatBody) {
          // 确保聊天内容区域可以正常滚动
          chatBody.style.overflowY = 'auto';
          // 添加touch事件监听器，明确允许滚动
          chatBody.addEventListener('touchmove', (e) => {
            // 不阻止默认行为，允许滚动
          }, { passive: true });
        }
      }
    },
    removeMobileTouchListeners() {
      if (this.isPortrait) {
        const header = this.$el.querySelector('.mob-chat-header');
        const footer = this.$el.querySelector('.chat-footer');
        if (header) {
          header.removeEventListener('touchstart', this.preventScroll);
          header.removeEventListener('touchmove', this.preventScroll);
        }
        if (footer) {
          // 对应上方仅绑定了 touchmove，这里也仅移除 touchmove
          footer.removeEventListener('touchmove', this.preventScroll);
        }
      }
    },
    // 修改preventScroll方法，优化安卓浏览器兼容性
    preventScroll(e) {
      // 对于百度浏览器，完全不阻止
      if (this.detectSpecialBrowsers()) {
        return;
      }
      // 对于聊天内容区域，完全允许滚动
      const target = e.target;
      const isInScrollableArea = target.closest('.chat-body');
      
      if (isInScrollableArea) {
        return; // 允许聊天内容区域滚动
      }
    
      // 只在非滚动区域且为touchmove事件时才考虑阻止默认行为 
      if (e.type === 'touchmove') {
        if (e.cancelable) {
          // 对于安卓浏览器，特别是百度和荣耀浏览器，使用标准preventDefault
          e.preventDefault();
        }
      }
      // 对于touchstart，不调用preventDefault，以允许按钮点击
    },
    handleBackTouchStart(e) {
      // 阻止触摸事件冒泡，避免被onPanelTouchMove拦截
      e.stopPropagation();
      this.isBackTouchActive = true;
      this.backTouchStartY = e.touches[0].clientY;
    },
    handleBackTouchEnd(e) {
      // 阻止触摸事件冒泡，避免被onPanelTouchMove拦截
      e.stopPropagation();
      if (this.isBackTouchActive) {
        this.goback();
      }
      this.isBackTouchActive = false;
    },
    handleNewChatTouchStart(e) {
      // 阻止触摸事件冒泡，避免被onPanelTouchMove拦截
      e.stopPropagation();
      this.newChat();
    },
    handleNewChatTouchEnd(e) {
      // 阻止触摸事件冒泡，避免被onPanelTouchMove拦截
      e.stopPropagation();
    },
    
    // 生成新的UUID
    generateNewUuid() {
      // 生成一个随机的UUID v4格式
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
      this.currentUuid = uuid;
      console.log('生成新的UUID:', uuid);
    },
    
    // 检查URL中的entryQuestion参数
    checkEntryQuestion() {
      try {
        const decodedQuestion = this.getEntryQuestionFromUrl();
        if (decodedQuestion) {
          console.log('检测到entryQuestion参数:', decodedQuestion);
          
          // 延迟执行，确保组件完全初始化
          this.pendingEntryQuestion = decodedQuestion;
          this.$nextTick(() => this.tryAutoSendEntry());
        }
      } catch (error) {
        console.warn('解析entryQuestion参数失败:', error);
      }
    },
    // 头部打字机
    startTypewriter() {
      try {
        this.robotTypedText = '';
        const chars = Array.from(this.robotFullText || '');
        let i = 0;
        const step = () => {
          if (i >= chars.length) return;
          this.robotTypedText += chars[i++];
          setTimeout(step, 60);
        };
        step();
      } catch (_) {}
    },
    // 欢迎区依次上滑出现
    startWelcomeSequence() {
      if (this.welcomeSequenceStarted) return;
      this.welcomeSequenceStarted = true;
      this.welcomeAppearIndex = 0;
      const total = 2 + Math.min(3, (this.recommendations && this.recommendations.length) || 0);
      
      const run = (i = -1) => {
        if (i >= total) return;
        this.welcomeAppearIndex = i + 1;
        setTimeout(() => run(i + 1), 150);
      };
      run();
    },
    
    // 添加用户日志
    async addUserLog(question, taskId, uuid) {
      var that = this
      try {
        const logData = {
          qa: question,
          role: "assistant", 
          taskId: taskId,
          uuid: uuid
        };
        
        await this.$axios.post(`${aiUrl}userSessionLog/client/addUserLog`, logData, {
          headers: {
            'token': that.token,
            'idvisitor': that.idvisitor || that.currentUuid || 'anonymous',
          },
        });
        console.log('用户日志记录成功');
      } catch (error) {
        console.warn('用户日志记录失败:', error);
      }
    },
    // 处理问题类型为4的车型对比替换逻辑
    // 修改processQuestionType4方法，实现实时监测
    processQuestionType4(botMsg) {
      const rawData = botMsg.questionType4Data;
      if (!rawData || !rawData.originalResult) {
        return;
      }
      
      try {
        // 解析原始车型数组
        let originalModels = [];
        try {
          originalModels = JSON.parse(rawData.originalResult);
          if (!Array.isArray(originalModels)) {
            originalModels = [];
          }
        } catch (e) {
          console.warn('Failed to parse originalResult:', e);
          originalModels = [];
        }
        
        // 定义检查机器人回复的函数
        const checkBotReply = () => {
          // 获取机器人回复的文本（去除HTML标签）
          const botText = this.stripHtml(botMsg.text);
          
          console.log('检查机器人回复中的车型，当前回复:', botText);
          console.log('原始车型数组:', originalModels)
          
          // 查找机器人回复中第一个出现在originalModels中的车型
          let matchedModel = null;
          for (const model of originalModels) {
            if (botText.includes(model)) {
              matchedModel = model;
              console.log('找到匹配车型:', matchedModel);
              break;
            }
          }
          
          if (matchedModel) {
            // 找到匹配的车型，构建新的数组（第一个元素替换为找到的车型） 
            // const updatedModels = [matchedModel, ...originalModels.filter(m => m && m !== matchedModel)];
            const updatedModels = [matchedModel];
            console.log('更新后的车型数组:', updatedModels);
            this.updateMultimodalWithModels(updatedModels, rawData.enhancedQuestion);
            
            // 标记处理完成
            botMsg.questionType4Data.isProcessing = false;
          } else {
            // 检查机器人是否已说完话
            if (rawData.isBotFinishedSpeaking) {
              console.log('机器人已说完话但未找到匹配车型，使用原始数据');
              // 只有在原始数据不为空时才调用
              if (originalModels.length > 0) {
                this.updateMultimodalWithModels(originalModels, rawData.enhancedQuestion);
              }
              botMsg.questionType4Data.isProcessing = false;
            } else {
              // 重要修改：机器人还在说话，5秒后再次尝试检查
              console.log('机器人还在说话，未找到匹配车型，5秒后再次尝试');
              setTimeout(() => {
                // 确保botMsg仍然存在且处于处理状态
                if (botMsg.questionType4Data && botMsg.questionType4Data.isProcessing) {
                  checkBotReply();
                }
              }, 5000);
            }
          }
        };
        
        // 重要修改：机器人开始说话后立即启动第一次检查，5秒后执行
        setTimeout(() => {
          if (botMsg.questionType4Data && botMsg.questionType4Data.isProcessing) {
            checkBotReply();
          }
        }, 5000);
      } catch (error) {
        console.error('处理问题类型为4时出错:', error);
        // 出错时使用原始数据
        try {
          const originalModels = JSON.parse(rawData.originalResult);
          if (Array.isArray(originalModels) && originalModels.length > 0) {
            this.updateMultimodalWithModels(originalModels, rawData.enhancedQuestion);
          }
          if (botMsg.questionType4Data) {
            botMsg.questionType4Data.isProcessing = false;
          }
        } catch (e) {
          console.error('使用原始数据时出错:', e);
        }
      }
    },

    // 更新多模态展示
    updateMultimodalWithModels(models, enhancedQuestion) {
      // 添加日志记录
      console.log('更新多模态展示，车型数组:', models);
      
      // 空值检查
      if (!models || models.length === 0) {
        console.warn('车型数组为空，不更新多模态展示');
        return;
      }
      
      if (!this.isPortrait) {
        const normalized = JSON.stringify(models);
        this.$emit('change-left-part', 'details', normalized, '4', enhancedQuestion);
        console.log('已发送多模态更新事件，车型:', models[0]);
      }
    },

    // 去除HTML标签的方法（如果已存在则无需添加）
    stripHtml(html) {
      if (!html) return '';
      // 创建临时元素，利用浏览器解析HTML并提取纯文本
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes spin360 {
  from { transform: rotate(0); }
  to { transform: rotate(360deg); }
}
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
@keyframes sheetSlideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}
@keyframes sheetSlideDown {
  from { transform: translateY(0); }
  to { transform: translateY(100%); }
}

/* Appear sequence: occupy space then slide up in */
.appear-seq {
  visibility: hidden;
  opacity: 0;
  transform: translateY(12px);
  transition: opacity .35s ease, transform .35s ease;
}
.appear-seq.showshow {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
} 
//媒体查询
@media (min-width: 767px) {
  .chat-bot {
    position: relative;
    z-index: 9999;
    height: 100%;
    width: 100%;
  }
  .chat-panel {
    height: 100%;
    width: 100%;
    background: #fff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
  }

  .pc-chat-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0;
    margin: 0 16px;
    border-bottom: 1px solid rgba(222, 222, 222, 1);
    
    color: #fff;
    .pc-head-icon {
      width: 74px;
    }
    
    .pc-header-actions { 
      display: flex;  
      align-items: center; 
      background: #05141F;
      padding: 4px 8px;
      border-radius: 6px;
      img {
        width: 16px;
        height: 16px;
      } 
      div {
        font-size: 12px;
        font-family: 'FZLanTingHeiS-R-GB';
      }
    }
  }

  .chat-body {
    flex: 1;
    overflow-y: auto;
    padding: 14px 14px 0 14px;
    
    /* 隐藏PC端滚动条 */
    &::-webkit-scrollbar {
      width: 0;
      background: transparent;
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
      background: transparent;
    }
    
    /* Firefox */
    scrollbar-width: none;
    
    /* IE/Edge */
    -ms-overflow-style: none;
  }
  .mob-welcome-message .bubble {
    // height: 309px;
  }
  .chat-msg {
    position: relative;
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
    word-break: break-all;
    
    .robot-head {
      width: 100%;
      padding: 0 25px;
      display: flex;
      justify-content: space-between;
      align-items: end;
      position: absolute;
      top: -16px;
      left: 0;
      .robot-head-img {
        width: 74px;
      }
      .robot-head-text {
        font-size: 14px;
        color: #000;
        font-family: 'FZLanTingHeiS-B-GB';
        padding-bottom: 8px;
      }
    }
    
    .avatar {
      // width: 28px;
      height: 28px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #fff;
      margin-right: 8px;
      &.bot { background: transparent; }
      &.user { background: transparent; }
    }
    
    .avatar-bot-img { 
      width: 24px; 
      height: auto; 
      display: block; 
    }
    .avatar-bot-text {
      font-size: 12px;
      line-height: 1;
      color: #000;
      font-family: 'FZLanTingHeiS-R-GB';
      padding-top: 6px;
      padding-left: 5px;
    }
    /* 正在思考文字样式 */
    .avatar-bot-text .thinking-text {
      color: #909399;
      font-size: 12px;
      margin-left: 8px;
    }

    /* 思考动画样式 */
    .thinking-animation {
      display: flex;
      justify-content: center;
      padding: 10px 0;
    }


    /* 思考动画样式 */
.thinking-container {
  display: inline-block;
  background: rgba(240, 242, 246, 1);
  border-radius: 10px 10px 10px 10px;
  padding: 10px 16px;
  min-width: 40px;
  margin-top: 10px; /* 新增：与机器人消息保持相同间距 */
}

.thinking-dots {
  display: flex;
  align-items: center;
  gap: 4px;
}

.thinking-dots .dot {
  width: 6px;
  height: 6px;
  background-color: #999;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out both;
}

.thinking-dots .dot:nth-child(1) {
  animation-delay: -0.32s;
}

.thinking-dots .dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

    .thinking-gif {
      width: 40px;
      height: 40px;
    }
    .bubble {
      max-width: 100%;
      background: rgba(240, 242, 246, 1);
      border-radius: 10px;
      padding: 10px 20px;
      margin-top: 10px;
      line-height: 1.5;
      font-size: 14px;
      color: #1a1a1a;
      
      .welcome-content {
        padding-top: 40px;
        .welcome-desc {
          background-color: rgba(6, 20, 31, 1);
          color: #fff;
          font-size: 11px;
          padding: 12px 9px;
          border-radius: 6px;
        }
        .welcome-desc-bottom {
          font-size: 10px;
          padding-left: 5px;
          font-family: 'FZLanTingHeiS-DB-GB';
          margin: 10px 0 6px 0;
        }
        .welcome-recommend {
          .ai-recommend-list {
            display: flex;
            flex-direction: column;
            gap: 5px;
            margin-bottom: 8px;
          }
          .recommend-item {
            min-width: 70%;
            width: fit-content;
            max-width: 100%;
            background: #fff;
            color: #05141F;
            font-size: 11px;
            line-height: 1;
            border-radius: 18px;
            padding: 9px 10px;
            cursor: pointer;
            border: 1px solid #eee;
            transition: all .2s;
            display: flex;
            align-items: center;
            .hashtag-icon {
              width: 12px;
              height: 12px;
              margin-right: 5px;
            }
          }
          .recommend-item:hover {
            background: rgba(205, 211, 221, 1);
          }
          .recommend-item.loading {
            cursor: default;
            pointer-events: none;
            .hashtag-icon {
              opacity: 0.6;
            }
            .loading-text {
              height: 12px;
              background: rgba(205, 211, 221, 1);
              border-radius: 6px;
              flex: 1;
              animation: pulse 1.5s ease-in-out infinite;
            }
          }
          .recommend-actions {
            display: flex;
            justify-content: flex-end;
            .change-btn:hover {
              background-color: #c0c4cf;
            }
            .change-btn {
              width: 22px;
              height: 22px;
              background: rgba(205, 211, 221, 1);
              border-radius: 6px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            }
            .change-icon {
              width: 14px;
              height: 14px;
            }
            .spinning {
              animation: spin360 .6s linear 1;
            }
          }
        }
      }
    }
  }

  .msg-bot {
    flex-direction: column;
    
    .bubble {
      width: 100%;
      min-height: 38px;
      background: rgba(240, 242, 246, 1);
      border-radius: 10px 10px 10px 0;
      padding: 10px 20px;
      margin-top: 10px;
      line-height: 1.5;
      font-size: 12px;
      color: #1a1a1a;
      //markdown 样式！！！
      ::v-deep .md-output a { color: #0070f3; word-break: break-all; transition: color 0.2s ease; }
      ::v-deep .md-output a:active { color: #0056b3; } 
      ::v-deep .md-output a:hover { text-decoration: underline; }
      //::v-deep .md-output code { background: #f6f8fa; padding: 0 3px; border-radius: 4px; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }
      //::v-deep .md-output pre { background: #f6f8fa; padding: 8px; border-radius: 6px; overflow: auto; }
      //::v-deep .md-output p { margin: 10px 0 !important; line-height: 1.8; }
      ::v-deep .md-output h1, ::v-deep .md-output h2, ::v-deep .md-output h3, ::v-deep .md-output h4, ::v-deep .md-output h5, ::v-deep .md-output h6 { margin: 8px 0 4px 0; font-weight: bold; color: #05141F; }
      ::v-deep .md-output h1 { font-size: 16px;padding: 0; }
      ::v-deep .md-output h2 { font-size: 14px; }
      ::v-deep .md-output h3 { font-size: 13px; }
      ::v-deep .md-output h4 { font-size: 12px; }
      // ::v-deep .md-output h5 { font-size: 12px; }
      // ::v-deep .md-output h6 { font-size: 12px; }
      ::v-deep .md-output ul { list-style: disc; margin: 6px 0; padding-left: 18px; }
      ::v-deep .md-output ol { list-style: decimal; margin: 6px 0; padding-left: 18px; }
      ::v-deep .md-output li { margin: 3px 0; }
      
      // // Markdown样式
      // h1, h2, h3 {
      //   margin: 8px 0 4px 0 !important;
      //   font-weight: bold !important;
      //   color: #05141F !important;
      // }
      
      // h1 {
      //   font-size: 16px !important;
      // }
      
      // h2 {
      //   font-size: 14px !important;
      // }
      
      // h3 {
      //   font-size: 13px !important;
      // }
      
      // strong {
      //   font-weight: bold !important;
      //   color: #05141F !important;
      // }
      
      // em {
      //   font-style: italic !important;
      // }
      
      // ul {
      //   margin: 8px 0 !important;
      //   padding-left: 20px !important;
      // }
      
      // li {
      //   margin: 4px 0 !important;
      // }
      
      // br {
      //   margin: 4px 0 !important;
      // }
      
      // 经销商按钮样式 - 在bubble内部
      // 车型对比按钮样式 - 在bubble内部
      .compare-btn {
        display: flex;
        align-items: center;
        background: #fff;
        font-size: 11px;
        border-radius: 18px;
        padding: 9px 10px;
        cursor: pointer;
        border: 1px solid transparent;
        transition: all 0.2s;
        line-height: 1;
        margin-top: 10px;
        width: 70%;
        
        img {
          width: 12px;
          height: 12px;
          margin-right: 5px;
        }
        
        .right-arrow {
          margin-right: 0;
          margin-left: auto;
          width: 7px;
          height: 11px;
        }
        
        &:hover {
          background: rgba(205, 211, 221, 1);
          color: #fff;
        }
      }
    }
    
    .disclaimer {
      font-size: 10px;
      font-family: 'FZLanTingHeiS-R-GB';
      color: rgba(55, 67, 76, 1);
      margin: 6px 0 8px 0;
    }
    
    .reply-suggest {
      margin-top: 6px;
      .ai-recommend-list { 
        display: flex; 
        flex-direction: column; 
        gap: 5px; 
        align-items: flex-start;
      }
      .recommend-item {
        background: rgba(240, 242, 246, 1);
        width: auto;
        color: rgba(55, 67, 76, 1);
        font-size: 11px;
        border-radius: 18px;
        padding: 9px 10px;
        cursor: pointer;
        border: 1px solid transparent;
        transition: all 0.2s;
        line-height: 1;
        display: inline-flex;
        align-items: center;
        .hashtag-icon {
          width: 12px;
          height: 12px;
          margin-right: 5px;
        }
      }
      .recommend-item:hover { 
        background: rgba(205, 211, 221, 1); 
      }
    }
  }

  .msg-user {
    flex-direction: row-reverse;
    
    .avatar { 
      display: none; 
    }
    
    .bubble {
      max-width: 100%;
      padding: 10px 20px;
      margin-top: 20px;
      line-height: 1.5;
      background: rgba(6, 20, 31, 1);
      color: #fff;
      border-radius: 10px 10px 0 10px;
      font-size: 12px;
    }
  }

  .chat-footer {
    border-top: 1px solid #EEE;
    background: #fff;
    padding: 10px;
    
    .toolbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      margin-bottom: 8px;
      .toolbar-text {
        font-size: 10px;
        font-family: 'FZLanTingHeiS-R-GB';
      }
      .toolbar-buttons {
        display: flex;
        width: 170px;
      }
      .tool-btn { 
        width: 80px;
        height: 28px;
        font-size: 11px;
        font-family: 'FZLanTingHeiS-R-GB';
        border-radius: 6px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .btn-light { 
        background: #fff; 
        border: 1px solid #05141F; 
        color: #05141F; 
      }
      .btn-dark { 
        background: #05141F; 
        border: 1px solid #05141F; 
        color: #fff; 
      }
    }
    
    .input-bar {
      display: block;
    }
  }

  /* 胶囊输入 + 圆形发送按钮 */
  .input-wrap {
    position: relative;
    border: 1px solid rgba(55, 67, 76, 1);
    border-radius: 24px;
    height: 44px;
    display: flex;
    align-items: center;
    background: #fff;
    padding-right: 56px; /* 为空出发送按钮空间 */
  }

  .input-wrap ::v-deep .el-input__inner {
    border: none;
    height: 44px;
    line-height: 44px;
    padding: 0 14px;
    background: transparent;
    box-shadow: none;
  }

  .send-circle {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: transparent;
  }

  .send-circle img { 
    width: 100%; 
    height: 100%; 
    display: block; 
  }

  .send-circle[disabled] { 
    opacity: .5; 
    cursor: not-allowed; 
  }

  /* 面板内-bottom sheet 弹层 */
  .form-mask {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 60px;
    width: 100%;
    background: rgba(0,0,0,0.35);
    z-index: 1000;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .form-sheet {
    position: relative;
    width: 100%;
    max-width: 100%;
    background: #fff;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    overflow: auto;
    transform: translateY(100%);
    animation: sheetSlideUp .25s ease-out forwards;
    
    &.closing {
      animation: sheetSlideDown .25s ease-out forwards;
    }
  }
}

@media (max-width: 767px) {
  .compare-header-mob {
    display: flex;
    align-items: center;
    height: calc(46 / 375 * 100vw);
    // padding: 0 calc(16 / 375 * 100vw);
    // background-color: rgba(6, 20, 31, 1);
    font-size: calc(16 / 375 * 100vw);
    font-family: 'FZLanTingHeiS-B-GB';
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .compare-overlay-panel {
    top: 0;
    height: calc(100% - 0px);
    display: flex;
    flex-direction: column;
  }
  .compare-overlay-content {
    flex: 1;
    min-height: 0; /* 关键：使子滚动容器按剩余空间计算 */
    overflow: hidden; /* 由 Compare 内部的 scrollable 容器承接滚动 */
    /* 竖向滚动交给 Compare 根容器，避免与横向冲突 */
    touch-action: pan-y;
  }
  .compare-overlay-content-iv{
       flex: 1;
    min-height: 0; /* 关键：使子滚动容器按剩余空间计算 */
    overflow: auto; /* 由 Compare 内部的 scrollable 容器承接滚动 */
    /* 竖向滚动交给 Compare 根容器，避免与横向冲突 */
    touch-action: pan-y;

 
        height: calc(100vh - 62px);
        display: flex; 
        flex-direction: column;
  }
  /* 移动端经销商弹窗样式（头部露出） */
  .dealers-overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;
    pointer-events: auto;
  }
  .dealers-overlay-panel {
    position: absolute;
    left: 0;
    width: 100%;
    background: #fff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    pointer-events: auto;
  }
  .dealers-overlay-close {
    position: absolute;
    right: calc(12 / 375 * 100vw);
    top: calc(12 / 375 * 100vw);
    width: calc(28 / 375 * 100vw);
    height: calc(28 / 375 * 100vw);
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    font-size: calc(18 / 375 * 100vw);
    line-height: 1;
  }
  .dealers-overlay-panel .dealers-container {
    flex: 1;
  }
  .chat-bot {
    position: relative;
    z-index: 9999;
    height: 100dvh;
    width: 100%;
  }
  
  .chat-panel {
    height: 100dvh;
    width: 100%;
    background: #fff;
    border-radius: calc(12 / 375 * 100vw);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
  }
  
  .mob-chat-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: calc(14 / 375 * 100vw) calc(16 / 375 * 100vw);
    
    .mob-back-icon {
      width: calc(34 / 375 * 100vw);
      height: calc(26 / 375 * 100vw);
      cursor: pointer;
    }
    
    .mob-head-icon {
      width: calc(45 / 375 * 100vw);
    }
    
    .mob-newchat-icon {
      width: calc(34 / 375 * 100vw);
      height: calc(26 / 375 * 100vw);
      cursor: pointer;
    }
  }
  
  .chat-body {
    flex: 1;
    overflow-y: auto;
    padding: 0 calc(14 / 375 * 100vw) 0 calc(14 / 375 * 100vw);
    -webkit-overflow-scrolling: touch; /* 惯性滚动 */
    overscroll-behavior: contain; /* 到边界时不把滚动传给外层 */
  }
  .robot-head-container-mob {
    width: 100%;
    height: calc(180 / 375 * 100vw - 10vw);//calc(180 / 375 * 100vw);
    position: relative;
    overflow: hidden;
    .blue-background {
      width: calc(236 / 375 * 100vw - 20vw);// calc(236 / 375 * 100vw)
      height: calc(236 / 375 * 100vw - 20vw);// calc(236 / 375 * 100vw)
      position: absolute;
      top: 45%;//50%
      left: 50%;
      transform: translate(-50%, -50%); 
    }
    .robot-head-img {
      position: absolute;
      width: calc(94 / 375 * 100vw);
      top: 45%;//50%
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }
    
    .robot-head-text {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: calc(50% + 45 / 375 * 100vw - 2vw );//calc(50% + 45 / 375 * 100vw);
      font-size: calc(17.6 / 375 * 100vw);
      color: #000;
      font-family: 'FZLanTingHeiS-B-GB';
      text-align: center;
      z-index: 3;
      white-space: nowrap;
    }
  }
  .mob-welcome-message .bubble {
    width: 100%;
    height: calc(292 / 375 * 100vw);
  }
  .chat-msg {
    position: relative;
    display: flex;
    align-items: flex-start;
    margin-bottom: calc(12 / 375 * 100vw);
    
    .robot-head {
      width: 100%;
      padding: 0 calc(25 / 375 * 100vw);
      display: flex;
      justify-content: space-between;
      align-items: end;
      position: absolute;
      top: calc(-2 / 375 * 100vw);
      left: 0;
      
    }
    
    .avatar {
      // width: calc(28 / 375 * 100vw);
      height: calc(28 / 375 * 100vw);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: calc(12 / 375 * 100vw);
      color: #fff;
      margin-right: calc(8 / 375 * 100vw);
      
      &.bot {
        background: transparent;
      }
      
      &.user {
        background: transparent;
      }
    }
    
    .avatar-bot-img {
      width: calc(24 / 375 * 100vw);
      //height: calc(24 / 375 * 100vw);
      height: auto; 
      display: block;
    }
    .avatar-bot-text {
      font-size: calc(12 / 375 * 100vw);
      line-height: 1;
      color: #000;
      font-family: 'FZLanTingHeiS-R-GB';
      padding-top: calc(6 / 375 * 100vw);
      padding-left: calc(5 / 375 * 100vw);
    }
    .avatar-bot-text .thinking-text {
      font-size: calc(12/375*100vw);
      margin-left: calc(8/375*100vw);
    }
    
    .thinking-gif {
      width: calc(40/375*100vw);
      height: calc(40/375*100vw);
    }
    // 111111111111
    .thinking-container {
    border-radius: calc(10 / 375 * 100vw);
    padding: calc(10 / 375 * 100vw) calc(16 / 375 * 100vw);
    min-width: calc(40 / 375 * 100vw);
    background: rgba(240, 242, 246, 1);
    display: inline-block;
    margin-top: calc(10 / 375 * 100vw); /* 新增：与机器人消息保持相同间距 */
 
  }
  
.thinking-dots {
  display: flex;
  align-items: center; 
    gap: calc(4 / 375 * 100vw);
}

.thinking-dots .dot {
  width: calc(6 / 375 * 100vw);
    height: calc(6 / 375 * 100vw);
  background-color: #999;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out both;
}

.thinking-dots .dot:nth-child(1) {
  animation-delay: -0.32s;
}

.thinking-dots .dot:nth-child(2) {
  animation-delay: -0.16s;
}



@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
   
  
  
    
    .bubble {
      max-width: 100%;
      background: rgba(240, 242, 246, 1);
      border-radius: calc(10 / 375 * 100vw);
      padding: calc(10 / 375 * 100vw) calc(10 / 375 * 100vw);
      // margin-top: calc(20 / 375 * 100vw);
      line-height: 1.5;
      font-size: calc(14 / 375 * 100vw);
      color: #1a1a1a;
      
      .welcome-content {
        // padding-top: calc(40 / 375 * 100vw);
        
        .welcome-desc {
          background-color: rgba(6, 20, 31, 1);
          color: #fff;
          font-size: calc(12 / 375 * 100vw);
          padding: calc(12 / 375 * 100vw) calc(9 / 375 * 100vw);
          border-radius: calc(6 / 375 * 100vw);
        }
        
        .welcome-desc-bottom {
          font-size: calc(10 / 375 * 100vw);
          padding-left: calc(5 / 375 * 100vw);
          font-family: 'FZLanTingHeiS-DB-GB';
          margin: calc(10 / 375 * 100vw) 0;
          text-align: center;
        }
        
        .welcome-recommend {
          .ai-recommend-list {
            display: flex;
            flex-direction: column;
            gap: calc(8 / 375 * 100vw);
            margin-bottom: calc(8 / 375 * 100vw);
            padding: 0 calc(10 / 375 * 100vw);
          }
          
          .recommend-item {
            width: 100%;
            background: #fff;
            color: #05141F;
            font-size: calc(14 / 375 * 100vw);
            line-height: 1;
            border-radius: calc(22 / 375 * 100vw);
            padding: calc(14 / 375 * 100vw) calc(10 / 375 * 100vw);
            cursor: pointer;
            border: 1px solid #eee;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            
            .hashtag-icon {
              width: calc(13.5 / 375 * 100vw);
              height: calc(13.5 / 375 * 100vw);
              margin-right: calc(5 / 375 * 100vw);
            }
          }
          
          // .recommend-item:hover {
          //   background: rgba(205, 211, 221, 1);
          // }
          
          .recommend-item.loading {
            cursor: default;
            pointer-events: none;
            
            .hashtag-icon {
              opacity: 0.6;
            }
            
            .loading-text {
              height: calc(12 / 375 * 100vw);
              background: rgba(205, 211, 221, 1);
              border-radius: calc(6 / 375 * 100vw);
              flex: 1;
              animation: pulse 1.5s ease-in-out infinite;
            }
          }
          
          .recommend-actions {
            display: flex;
            justify-content: flex-end;
            
            .change-btn {
              width: calc(22 / 375 * 100vw);
              height: calc(22 / 375 * 100vw);
              
              border-radius: calc(6 / 375 * 100vw);
              display: inline-flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            }
            
            .change-icon {
              width: calc(18 / 375 * 100vw);
              height: calc(18 / 375 * 100vw);
            }
            
            .spinning {
              animation: spin360 0.6s linear 1;
            }
          }
        }
      }
    }
  }
  
  .msg-bot {
    flex-direction: column;
    
    .bubble {
      width: 100%;
      background: rgba(240, 242, 246, 1);
      border-radius: calc(10 / 375 * 100vw) calc(10 / 375 * 100vw) calc(10 / 375 * 100vw) 0;
      padding: calc(20 / 375 * 100vw) calc(20 / 375 * 100vw);
      margin-top: calc(10 / 375 * 100vw);
      line-height: 1.5;
      font-size: calc(14 / 375 * 100vw);
      color: #1a1a1a;
      //markdown 样式！！！
      ::v-deep .md-output a { color: #0070f3; word-break: break-all; transition: color 0.2s ease; }
      ::v-deep .md-output a:active { color: #0056b3; } 
      ::v-deep .md-output a:hover { text-decoration: underline; }
      // ::v-deep .md-output code { background: #f6f8fa; padding: 0 calc(3 / 375 * 100vw); border-radius: calc(4 / 375 * 100vw); font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }
      // ::v-deep .md-output pre { background: #f6f8fa; padding: calc(8 / 375 * 100vw); border-radius: calc(6 / 375 * 100vw); overflow: auto; }
      // ::v-deep .md-output p { margin: calc(10 / 375 * 100vw) 0; line-height: 1.8; }
      ::v-deep .md-output h1, ::v-deep .md-output h2, ::v-deep .md-output h3, ::v-deep .md-output h4, ::v-deep .md-output h5, ::v-deep .md-output h6 { margin: calc(8 / 375 * 100vw) 0 calc(4 / 375 * 100vw) 0; font-weight: bold; color: #05141F; }
      ::v-deep .md-output h1 { font-size: calc(16 / 375 * 100vw);padding: 0; }
      ::v-deep .md-output h2 { font-size: calc(14 / 375 * 100vw); }
      ::v-deep .md-output h3 { font-size: calc(13 / 375 * 100vw); }
      ::v-deep .md-output h4 { font-size: calc(12 / 375 * 100vw); }
      // ::v-deep .md-output h5 { font-size: calc(12 / 375 * 100vw); }
      // ::v-deep .md-output h6 { font-size: calc(12 / 375 * 100vw); }
      ::v-deep .md-output ul { list-style: disc; margin: calc(6 / 375 * 100vw) 0; padding-left: calc(18 / 375 * 100vw); }
      ::v-deep .md-output ol { list-style: decimal; margin: calc(6 / 375 * 100vw) 0; padding-left: calc(18 / 375 * 100vw); }
      ::v-deep .md-output li { margin: calc(3 / 375 * 100vw) 0; }
      
      // Markdown样式
      h1, h2, h3 {
        margin: calc(8 / 375 * 100vw) 0 calc(4 / 375 * 100vw) 0 !important;
        font-weight: bold !important;
        color: #05141F !important;
      }
      
      h1 {
        font-size: calc(16 / 375 * 100vw) !important;
      }
      
      h2 {
        font-size: calc(14 / 375 * 100vw) !important;
      }
      
      h3 {
        font-size: calc(13 / 375 * 100vw) !important;
      }
      
      strong {
        font-weight: bold !important;
        color: #05141F !important;
      }
      
      em {
        font-style: italic !important;
      }
      
      ul {
        margin: calc(8 / 375 * 100vw) 0 !important;
        padding-left: calc(20 / 375 * 100vw) !important;
      }
      
      li {
        margin: calc(4 / 375 * 100vw) 0 !important;
      }
      
      br {
        margin: calc(4 / 375 * 100vw) 0 !important;
      }
      
      // 经销商按钮样式 - 在bubble内部
      // 车型对比按钮样式 - 在bubble内部
      .compare-btn {
        display: flex;
        align-items: center;
        background: #fff;
        font-size: calc(14 / 375 * 100vw);
        border-radius: calc(22 / 375 * 100vw);
        padding: calc(14 / 375 * 100vw) calc(12 / 375 * 100vw);
        cursor: pointer;
        border: 1px solid transparent;
        transition: all 0.2s;
        line-height: 1;
        margin-top: calc(15 / 375 * 100vw);
        width: 100%;
        
        img {
          width: calc(13.5 / 375 * 100vw);
          height: calc(13.5 / 375 * 100vw);
          margin-right: calc(5 / 375 * 100vw);
        }
        
        .right-arrow {
          margin-right: 0;
          margin-left: auto;
          width: calc(7 / 375 * 100vw);
          height: calc(12 / 375 * 100vw);
        }
        
        // &:hover {
        //   background: rgba(205, 211, 221, 1);
        //   color: #fff;
        // }
      }
    }
    
    .disclaimer {
      font-size: calc(10 / 375 * 100vw);
      font-family: 'FZLanTingHeiS-R-GB';
      color: rgba(55, 67, 76, 1);
      margin: calc(6 / 375 * 100vw) 0 calc(8 / 375 * 100vw) 0;
    }
    
    .reply-suggest {
      margin-top: calc(6 / 375 * 100vw);
      
      .ai-recommend-list {
        display: flex;
        flex-direction: column;
        gap: calc(8 / 375 * 100vw);
        align-items: flex-start;
      }
      
      .recommend-item {
        background: rgba(240, 242, 246, 1);
        width: auto;
        color: rgba(55, 67, 76, 1);
        font-size: calc(11 / 375 * 100vw);
        border-radius: calc(18 / 375 * 100vw);
        padding: calc(9 / 375 * 100vw) calc(10 / 375 * 100vw);
        cursor: pointer;
        border: 1px solid transparent;
        transition: all 0.2s;
        line-height: 1;
        display: inline-flex;
        align-items: center;
        
        .hashtag-icon {
          width: calc(11 / 375 * 100vw);
          height: calc(11 / 375 * 100vw);
          margin-right: calc(5 / 375 * 100vw);
        }
      }
      
      // .recommend-item:hover {
      //   background: rgba(205, 211, 221, 1);
      //   color: #fff;
      // }
    }
  }
  
  .msg-user {
    flex-direction: row-reverse;
    
    .avatar {
      display: none;
    }
    
    .bubble {
      max-width: 100%;
      padding: calc(10 / 375 * 100vw) calc(20 / 375 * 100vw);
      margin-top: calc(20 / 375 * 100vw);
      line-height: 1.5;
      background: rgba(6, 20, 31, 1);
      color: #fff;
      border-radius: calc(10 / 375 * 100vw) calc(10 / 375 * 100vw) 0 calc(10 / 375 * 100vw);
      font-size: calc(14 / 375 * 100vw);
    }
  }
  
  .chat-footer {
    border-top: 1px solid #EEE;
    background: #fff;
    padding: calc(10 / 375 * 100vw);
    
    .toolbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: calc(10 / 375 * 100vw);
      margin-bottom: calc(8 / 375 * 100vw);
      
      .toolbar-text {
        font-size: calc(10 / 375 * 100vw);
        font-family: 'FZLanTingHeiS-R-GB';
      }
      
      .toolbar-buttons {
        display: flex;
        width: calc(170 / 375 * 100vw);
      }
      
      .tool-btn {
        width: calc(80 / 375 * 100vw);
        height: calc(28 / 375 * 100vw);
        font-size: calc(12 / 375 * 100vw);
        font-family: 'FZLanTingHeiS-R-GB';
        border-radius: calc(6 / 375 * 100vw);
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      
      .btn-light {
        background: #fff;
        border: 1px solid #05141F;
        color: #05141F;
      }
      
      .btn-dark {
        background: #05141F;
        border: 1px solid #05141F;
        color: #fff;
      }
    }
    
    .input-bar {
      display: block;
    }
  }
  
  /* 胶囊输入 + 圆形发送按钮 */
  .input-wrap {
    position: relative;
    border: 1px solid rgba(55, 67, 76, 1);
    border-radius: calc(24 / 375 * 100vw);
    height: calc(44 / 375 * 100vw);
    display: flex;
    align-items: center;
    background: #fff;
    padding-right: calc(56 / 375 * 100vw); /* 为空出发送按钮空间 */
  }
  
  .input-wrap ::v-deep .el-input__inner {
    border: none;
    height: calc(44 / 375 * 100vw);
    line-height: calc(44 / 375 * 100vw);
    padding: 0 calc(14 / 375 * 100vw);
    background: transparent;
    box-shadow: none;
  }
  
  .send-circle {
    position: absolute;
    right: calc(8 / 375 * 100vw);
    top: 50%;
    transform: translateY(-50%);
    width: calc(36 / 375 * 100vw);
    height: calc(36 / 375 * 100vw);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: transparent;
  }
  
  .send-circle img {
    width: 100%;
    height: 100%;
    display: block;
  }
  
  .send-circle[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  /* 面板内-bottom sheet 弹层 */
  .form-mask {
    position: absolute;
    left: 0;
    top: 0;
    bottom: calc(0 / 375 * 100vw);
    width: 100%;
    background: rgba(0, 0, 0, 0.35);
    z-index: 1000;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  
  .form-sheet {
    position: relative;
    width: 100%;
    max-width: 100%;
    background: #fff;
    border-top-left-radius: calc(12 / 375 * 100vw);
    border-top-right-radius: calc(12 / 375 * 100vw);
    overflow: auto;
    transform: translateY(100%);
    animation: sheetSlideUp 0.25s ease-out forwards;
    
    &.closing {
      animation: sheetSlideDown 0.25s ease-out forwards;
    }
  }
}
/* 移动设备特殊处理 - 强制固定布局 */
@media (max-width: 768px) {
  .chat-panel {
    /* 确保使用固定定位 */
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    /* 防止内容溢出 */
    box-sizing: border-box !important;
  }

  .baidu-browser-fix {
    height: 100vh !important; 
        position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100vh !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    /* 防止内容溢出 */
    box-sizing: border-box !important;
  }

  .chat-body {
    /* 确保内容区域可滚动 */
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
    touch-action: pan-y !important;
    /* 优化渲染性能 */
    -webkit-transform: translateZ(0) !important;
    transform: translateZ(0) !important;
    will-change: transform !important;
  }
  
  .chat-footer {
    /* 确保底部固定 */
    margin-top: auto !important;
    flex-shrink: 0 !important;
  }
  
  /* 防止各种浏览器的默认行为干扰 */
  * {
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  input, textarea {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
}
</style>


